import * as React from 'react';
import { AuthState } from '../auth/auth.types';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import { PaymentsState, PaymentMethodType, Payment } from './Types';
import { isAdminAccount, isImpersonating } from '../admin/Util';
import { AdminState } from '../admin/admin.types';
import checkboxHOC from 'react-table/lib/hoc/selectTable';
import {
  isPaymentDisabled,
  cannotWrite,
  isMemberDisabled,
  cannotUpdate,
  isAttendancesDisabled
} from '../util/permission.util';
import { BusinessState } from '../business/business.types';
import ReactTable from 'react-table';
import CommonFeatures from '../commons/CommonFeatures';
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody,
} from 'react-accessible-accordion';
import AutoComplete from 'material-ui/AutoComplete';
import './payment-list-accordian.css';
import {
  PayerInfo,
  BillingResponseData,
  PayersState,
  PayMethodsInfo,
  PayMethodsState,
  Currency
} from '../billing/billing.types';
import { PaymentMethod, PaymentMethodLabel, CURRENCY_FIELD_LABEL, currencyList } from '../billing/billing.const';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Edit from 'material-ui/svg-icons/image/edit';
import { PAYMENT, MEMBER } from 'src/account/Constants';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import Chip from 'material-ui/Chip';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import { overlayStyle, renderOverlayLoading } from '../util/Overlay';
import {
  isValidName,
  isValidEmail,
  isValidPostalCode,
  isValidPhone,
  validateCreditCardNumber
} from '../util/Validation';
import { DEFAULT_COUNTRY_SELECTION, DEFAULT_PROVINCE_SELECTION } from '../app/app.const';
import { black } from 'material-ui/styles/colors';
import { CountryCode, ProvinceCode } from '../geo/geo.types';
import { countries, provinces } from '../geo/geo.const';
import { getProvinces } from '../geo/geo';
import { formatPostalCode } from '../util/address.util';
import Phone from 'react-phone-number-input';
import {
  MembersState,
  MembersResponseData,
  MakePaymentRequest,
  PaymentTermCode,
  Member
} from '../members/members.types';
import FlatButton from 'material-ui/FlatButton';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { M3BASIC } from '../business/business.constants';
import * as validator from 'validator';
import { renderCreditCardIcon, parseCreditCardType } from '../creditcard/CreditCardIconHelper';
import * as creditcardutils from 'creditcardutils';
import { CreditCardType } from '../payments/Types';
import {
  NONE,
  CREDIT_CARD_LENGTH,
  AMEX_LENGTH,
  REMOVE_RIDIRECT_FROM_MEMBER,
  REMOVE_PAYMENT_DETAILS
} from '../payments/Constants';
import * as moment from 'moment';
import {
  paymentTerms,
  paymentTermsCC,
  DEFAULT_PAYER,
  defaultPaymentMethodWith,
  DEFAULT_PAYMENT,
  DEFAULT_PAY_METHOD_ID,
  PAYMENTS_TABLE_ROW_CLICKED,
  NEW_MEMBER_PAYMENT_CLICKED,
  DEFAULT_MEMBER_ID,
  MAX_NOTE_LENGTH,
  YEARLY,
  MONTHLY,
  BI_WEEKLY,
  WEEKLY,
  DEFAULT_DOWN_PAYMENT,
  DEFAULT_TOTAL,
  DEFAULT_AMOUNT_PER_TRANSACTION,
  DEFAULT_ZERO_AMOUNT_STRING
} from '../members/members.constants';
import Checkbox from 'material-ui/Checkbox';
import { isValidAmount } from '../util/Validation';
import ReactDatePicker from 'react-datepicker';
import { CREATED } from '../programs/Constants';
import { EntityStatus } from '../programs/Types';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import Avatar from 'material-ui/Avatar';
import SectionPanel from '../util/SectionPanelComponent';
import { mmsStore } from 'src/app/app.config';
import { FormattedNumber } from 'react-intl';
import PaymentsDetailsModal from './paymentsDetailsModal';
import { getPayMethods } from 'src/billing/billing.actions';
import { Filter } from 'src/util/filter';
import paymentsReducer from './Reducer';
const CheckboxTable = checkboxHOC(ReactTable);
const PAYMENT_START_DAYS = [1, 5, 10, 15, 20, 25];
const THIRTY_ONE_DAYS = [1, 2, 3, 4, 5,
  6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27, 28, 29, 30, 31];
const THIRTY_DAYS = [1, 2, 3, 4, 5,
  6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27, 28, 29, 30];
const TWENTY_NINE_DAYS = [1, 2, 3, 4, 5,
  6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27, 28, 29];
const TWENTY_EIGHT_DAYS = [1, 2, 3, 4, 5,
  6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27, 28];
const MONTHS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const THIRTY_DAYS_MONTH = [4, 6, 9, 11];
const THIRTY_ONE_DAYS_MONTH = [1, 3, 5, 7, 8, 10, 12];
const CANADA_TRANSIT_NUMBER_LENGTH = 5;
const CANADA_FINANCIAL_INSTITUTION_NUMBER_LENGTH = 3;
const CANADA_MAX_ACCOUNT_NUMBER_LENGTH = 18;
const DIVIDER = ' / ';
const MAX_LENGTH_FOR_DB = 20;
const MAX_LENGTH = 250;

const filteredYear = (): Array<number> => {
  const date = new Date();
  if (date.getMonth() === 1) {
    return [date.getFullYear() - 1, date.getFullYear(), date.getFullYear() + 1];
  } else {
    return [date.getFullYear(), date.getFullYear() + 1];
  }
};

const filterMonth = (year: number, month: number): boolean => {
  const date = new Date();
  if (year === date.getFullYear()) {
    return month >= date.getMonth();
  } else if (year > date.getFullYear()) {
    return true;
  } else if (year < date.getFullYear()) {
    return month === 12;
  } else {
    return false;
  }
};

const renderStartMonthOptions = (
  isNew: boolean,
  selectedYear?: number,
  selectedMonth?: number,
): Array<JSX.Element> => {
  if (!isNew && selectedMonth) {
    return [<MenuItem key={0} value={selectedMonth} primaryText={selectedMonth} />];
  } else if (selectedYear) {
    return MONTHS
      .filter((month: number) => filterMonth(selectedYear, month))
      .map((filtered: number, index: number) => {
        return (
          <MenuItem key={index} value={filtered} primaryText={filtered} />
        );
      });
  } else {
    return null;
  }
};

const renderExtraPaymentStartDayMenuItem = (
  isPaymentDetailDisplayMode: boolean,
  day?: number,
  paymentMethodType?: string
): JSX.Element => {
  if (day && PAYMENT_START_DAYS.filter((value: number) => value === day).length === 0
    && !isPaymentDetailDisplayMode && (paymentMethodType && paymentMethodType !== 'CREDITCARD')) {
    return (
      <MenuItem key={PAYMENT_START_DAYS.length} value={day} primaryText={day} />
    );
  } else {
    return (<div />);
  }
};

const fieldStyles = {
  rootStyle: {
    cursor: 'text'
  },
  textStyle: {
    cursor: 'text',
    color: black
  }
};

type PayerRequest = {
  readonly id?: number
  readonly firstName: string
  readonly lastName: string
  readonly initial: string
  readonly address: string
  readonly city: string
  readonly country: CountryCode | ''
  readonly province: ProvinceCode | ''
  readonly postalCode: string
  readonly mobile1: string
  readonly mobile2: string
  readonly email: string
};

type PayMethodRequest = {
  readonly payMethodType: PaymentMethodType
  readonly voidCheque?: {
    readonly accountHolderName: string
    readonly financialInstitutionName: string
    readonly transitNumber: string
    readonly financialInstitutionNumber: string
    readonly bankAccountNumber: string
  }
  readonly creditcard?: {
    readonly cardHolderName: string
    readonly cardNumber: string
    readonly mm: string
    readonly yy: string
    readonly cvc: string
    readonly creditCardType: CreditCardType
  }
};

type NewPayerRequestError = {
  readonly firstNameError: string
  readonly lastNameError: string
  readonly initialError: string
  readonly addressError: string
  readonly cityError: string
  readonly postalCodeError: string
  readonly mobile1Error: string
  readonly mobile2Error: string
  readonly emailError: string
};

type NewPayMethodRequestError = {
  readonly voidCheque?: {
    readonly accountHolderNameError: string
    readonly financialInstitutionNameError: string
    readonly transitNumberError: string
    readonly financialInstitutionNumberError: string
    readonly bankAccountNumberError: string
  }
  readonly creditcard?: {
    readonly cardHolderNameError: string
    readonly cardNumberError: string
    readonly mmyyError: string
    readonly cvcError: string
  }
};

type Props = {
  readonly authState: AuthState
  readonly adminState: AdminState
  readonly paymentsState: PaymentsState
  readonly businessState: BusinessState
  readonly payersState: PayersState
  readonly membersState: MembersState
  readonly payMethodsState: PayMethodsState
  readonly toAdminDashboard: () => void
  readonly toDashboard: () => void
  readonly getPayers: () => Promise<BillingResponseData>
  readonly createPayer: (
    businessId: number,
    firstName: string,
    lastName: string,
    initial: string,
    address: string,
    city: string,
    country: CountryCode | '',
    province: ProvinceCode | '',
    postalCode: string,
    mobile1: string,
    mobile2: string | undefined,
    email: string
  ) => Promise<BillingResponseData>
  readonly updatePayer: (
    businessId: number,
    id: number,
    firstName: string,
    lastName: string,
    initial: string,
    address: string,
    city: string,
    country: CountryCode | '',
    province: ProvinceCode | '',
    postalCode: string,
    mobile1: string,
    mobile2: string | undefined,
    email: string
  ) => Promise<BillingResponseData>
  readonly getMembers: () => Promise<MembersResponseData>
  readonly getPayMethods: (payerId: number) => Promise<BillingResponseData>;
  readonly getAllPayMethods: () => Promise<BillingResponseData>;
  readonly createPayMethod: (
    payerId: number, paymentMethodType: string, accountHolderName: string,
    financialInstitutionName: string, transitNumber: string, financialInstitutionNumber: string,
    bankAccountNumber: string, cardHolderName: string, cardNumber: string, expiryMonth: string,
    expiryYear: string, cvc: string
  ) => Promise<BillingResponseData>
  readonly removePayMethod: (paymentMethodId: number) => Promise<BillingResponseData>
  readonly updateScheduledPayment: (
    id: number,
    chargeDate: number,
    amount: number
  ) => Promise<Response>
  readonly createPayment: (
    id: number,
    paymentType: string,
    downPayment: number,
    total: number,
    amountPerTransaction: number,
    currency: Currency | '',
    term: string,
    numberOfTransactions: number,
    startDate: number,
    payerId: number,
    memberId: number,
    paymentMethodId: number,
    continuous: boolean,
    schedules: {
      scheduledPaymentId: number,
      chargeDate: number,
      amount: number,
      status: string
    }[],
    description?: string
  ) => Promise<Response>
  readonly updatePayment: (
    id: number,
    payerId: number,
    paymentMethodId: number,
    continuous: boolean,
    amountPerTransaction: number,
    schedules: {
      scheduledPaymentId: number,
      chargeDate: number,
      amount: number,
      status: string
    }[],
    description?: string) => Promise<Response>
  readonly cancelMemberPayment: (paymentId: number) => Promise<Response>
  readonly getPaymentList: () => Promise<Response>
  readonly getPaymentDetails: (paymentId: number) => Promise<Response>
  readonly getMember: (memberId: number) => Promise<Response>
};

type States = {
  readonly checkedSameAsMember: boolean
  readonly payerSearchText: string
  readonly memberSearchText: string
  readonly payerSearchData: string[]
  readonly memberSearchData: string[]
  readonly selectedPayer?: PayerInfo
  readonly selectedMember?: Member
  readonly loadingPayers: boolean
  readonly loadingPayersError: string
  readonly openPayerModal: boolean
  readonly payerRequest?: PayerRequest
  readonly payMethodRequest?: PayMethodRequest
  readonly newPayerRequestError?: NewPayerRequestError
  readonly newPayMethodRequestError?: NewPayMethodRequestError
  readonly isPayerDisplayMode: boolean
  readonly loadingCreatePayer: boolean
  readonly loadingUpdatePayer: boolean
  readonly creatingPayerError: string
  readonly newPayer?: PayerInfo
  readonly isPayerEditMode: boolean
  readonly loadingMembers: boolean
  readonly loadingMembersError: string
  readonly openNewPaymentMethodModal: boolean
  readonly isPaymentMethodDisplayMode: boolean
  readonly isPaymentMethodEditMode: boolean
  readonly selectedPaymentMethod?: PayMethodsInfo
  readonly loadingPayMethods: boolean
  readonly loadingPayMethodsError: string
  readonly updatingPayerError: string
  readonly loadingDeletePayMethod: boolean
  readonly deletingPayMethodError: string
  readonly creatingPayMethodError: string
  readonly loadingCreatePayMethod: boolean
  readonly selectedPaymentDetail: MakePaymentRequest
  readonly isPaymentDetailDisplayMode: boolean
  readonly scheduledPaymentsForUpdate: {
    chargeDate: any,
    newChargeDate?: any,
    amount: string,
    newAmount?: string,
    editableFieldError: string,
    scheduledPaymentId?: number,
    status?: EntityStatus
  }[],
  readonly creatingPayment: boolean
  readonly createPaymentError: string
  readonly selectedRow?: any
  readonly isNew: boolean
  readonly activePaymentFilter: string
  readonly loadingPaymentList: boolean
  readonly loadingPaymentListError: string
  readonly loadingPaymentDetails: boolean
  readonly loadingPaymentDetailsError: string
  readonly filterByMemberName: string
  readonly filterByDescription: string
  readonly cancellingPayment: boolean
  readonly cancellingPaymentError: string
  readonly openCancelPaymentModal: boolean
  readonly prevSelectedPaymentMethodType: string
  readonly selectAll: boolean
  readonly loadingActions: boolean
  readonly selection: number[]
  readonly openFilterModal: boolean
  readonly filters: Filter[]
  readonly filterField: string
  readonly filterOperation: string
  readonly filterValue: string
};

class PaymentListComponent extends React.Component<Props, States> {

  checkboxTable = null;

  constructor(props: Props) {
    super(props);

    this.state = {
      checkedSameAsMember: false,
      payerSearchText: '',
      memberSearchText: '',
      payerSearchData: [],
      memberSearchData: [],
      loadingPayers: false,
      loadingPayersError: '',
      openPayerModal: false,
      isPayerDisplayMode: true,
      loadingCreatePayer: false,
      creatingPayerError: '',
      isPayerEditMode: false,
      loadingUpdatePayer: false,
      loadingMembers: false,
      loadingMembersError: '',
      openNewPaymentMethodModal: false,
      isPaymentMethodDisplayMode: true,
      isPaymentMethodEditMode: false,
      loadingPayMethods: false,
      loadingPayMethodsError: '',
      updatingPayerError: '',
      loadingDeletePayMethod: false,
      deletingPayMethodError: '',
      creatingPayMethodError: '',
      loadingCreatePayMethod: false,
      payMethodRequest: {
        payMethodType: PaymentMethod.VOIDCHEQUE
      },
      isPaymentDetailDisplayMode: false,
      selectedPaymentDetail: this.resetSelectedPaymentDetail(props),
      scheduledPaymentsForUpdate: [],
      creatingPayment: false,
      createPaymentError: '',
      isNew: false,
      activePaymentFilter: 'ALL',
      loadingPaymentList: false,
      loadingPaymentListError: '',
      loadingPaymentDetails: false,
      loadingPaymentDetailsError: '',
      filterByMemberName: '',
      filterByDescription: '',
      cancellingPayment: false,
      cancellingPaymentError: '',
      openCancelPaymentModal: false,
      prevSelectedPaymentMethodType: '',
      selectAll: false,
      loadingActions: false,
      selection: [],
      openFilterModal: false,
      filters: [],
      filterField: '',
      filterOperation: '',
      filterValue: ''
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (
      this.props !== nextProps &&
      nextProps.paymentsState.fromMemberComponent &&
      nextProps.payersState.payers.length > 0 &&
      nextProps.paymentsState.paymentList.length > 0
    ) {

      const { paymentsState, membersState, payMethodsState, payersState } = nextProps;
      const member = paymentsState.fromMemberComponent && paymentsState.fromMemberComponent.memberId &&
        membersState.members.find(m => m.id === paymentsState.fromMemberComponent.memberId);
      const payer = paymentsState.fromMemberComponent && paymentsState.fromMemberComponent.payerId &&
        payersState.payers.find(p => p.id === paymentsState.fromMemberComponent.payerId);
      const payment = paymentsState.fromMemberComponent && paymentsState.fromMemberComponent.paymentId &&
        paymentsState.paymentList.find(p => p.id === paymentsState.fromMemberComponent.paymentId);

      if (member && payer && payment) {
        nextProps.getPaymentDetails(payment.id).then(res => {
          const pm = membersState.member.payments.find(p => p.id === payment.id);

          return this.setState({
            selectedRow: paymentsState.paymentList.findIndex(p => p.id === payment.id),
            loadingPaymentDetails: false,
            loadingPaymentDetailsError: '',
            activePaymentFilter: 'ALL',
            isNew: false,
            selectedMember: membersState.members.find(m => m.id === payment.memberId),
            selectedPayer: payer,
            selectedPaymentMethod: pm ? pm.paymentMethod : undefined,
            prevSelectedPaymentMethodType: pm ? pm.paymentMethod.paymentMethodType : '',
            selectedPaymentDetail: {
              id: payment.id,
              newPaymentInfo: {
                ...DEFAULT_PAYMENT,
                numberOfTransactions: pm ? pm.numberOfTransactions : 0,
                term: pm ? pm.term : undefined
              },
              downPayment: pm ? pm.downPayment : undefined,
              total: pm ? pm.total : undefined,
              amountPerTransaction: pm ? pm.amountPerTransaction : undefined,
              startDate: pm ? pm.startDate : undefined,
              payerId: payment.payerId,
              memberId: payment.memberId,
              paymentMethodId: payment.paymentMethodId,
              continuous: pm ? pm.continuous : undefined,
              description: pm ? pm.description : undefined,
              schedules: [],
              // Only for display
              amountPerTransactionError: '',
              paymentError: {
                numOfTransactionError: ''
              },
              downPaymentError: '',
              newPayer: DEFAULT_PAYER,
              newPayMethod: defaultPaymentMethodWith(PaymentMethod.VOIDCHEQUE),
              paymentStartDate: {
                year: pm ? new Date(pm.startDate).getFullYear() : null,
                month: pm ? new Date(pm.startDate).getMonth() + 1 : null,
                day: pm ? new Date(pm.startDate).getDate() : null
              },
              downPaymentString: pm ? `${pm.downPayment}` : '0.00',
              amountPerTransactionString: pm ? `${pm.amountPerTransaction}` : '0.00',
              totalString: pm ? `${pm.total}` : '0.00',
              // Not a clean way. This is used in member create/update request.
              newScheduledPayments: pm ? pm.scheduleDetails.map(s => {
                return {
                  chargeDate: moment(new Date(s.chargeDate)),
                  amount: `${s.amount}`,
                  editableFieldError: '',
                  scheduledPaymentId: s.scheduledPaymentId,
                };
              }) :
                []
            },
            scheduledPaymentsForUpdate: pm ? pm.scheduleDetails.map(s => {
              return {
                chargeDate: moment(new Date(s.chargeDate)),
                newChargeDate: moment(new Date(s.chargeDate)),
                amount: `${s.amount}`,
                newAmount: `${s.amount}`,
                editableFieldError: '',
                scheduledPaymentId: s.scheduledPaymentId,
              };
            }) :
              []
          }, () => {
            mmsStore.dispatch({
              type: REMOVE_RIDIRECT_FROM_MEMBER
            });
            this.renderPaymentMethodSelect();
          }

          );
        });

      } else if (member && !payer && !payment) {
        this.setState({
          selectedMember: member,
          isNew: true
        }, () => {
          mmsStore.dispatch({
            type: REMOVE_RIDIRECT_FROM_MEMBER
          });
        });
      }

    }
  }

  componentWillUnmount() {
    this.resetAll();
  }

  componentDidMount() {
    const {
      authState,
      toAdminDashboard,
      adminState,
      toDashboard,
      getPayers,
      getMembers,
      getPaymentList,
      getAllPayMethods
    } = this.props;

    if (isAdminAccount(authState) && !isImpersonating(adminState)) {
      return toAdminDashboard();
    }

    if (!isMemberDisabled(authState, adminState)) {
      this.setState({
        loadingMembers: true
      }, () => getMembers().then(res => {
        switch (this.props.membersState.statusCode) {
          case 200:
            return this.setState({
              loadingMembers: false,
              loadingMembersError: '',
              memberSearchData: this.mapMemberToSearchData()
            });
          case 400:
            return this.setState({
              loadingMembers: false,
              loadingMembersError: 'Failed to load members'
            });
          case 403:
            return this.setState({
              loadingMembers: false,
              loadingMembersError: 'Failed to load members'
            });
          case 406:
            return this.setState({
              loadingMembers: false,
              loadingMembersError: 'Failed to load members'
            });
          default:
            return this.setState({
              loadingMembers: false
            });
        }
      }));
    }

    if (!isPaymentDisabled(authState, adminState)) {
      this.setState({
        loadingPayers: true
      }, () => getPayers().then(res => {
        switch (this.props.payersState.statusCode) {
          case 200:
            return this.setState({
              loadingPayers: false,
              loadingPayersError: '',
              payerSearchData: this.mapPayerInfoToSearchData()
            });
          case 400:
            return this.setState({
              loadingPayers: false,
              loadingPayersError: 'Failed to load payer list'
            });
          case 403:
            return this.setState({
              loadingPayers: false,
              loadingPayersError: 'Failed to load payer list'
            });
          case 406:
            return this.setState({
              loadingPayers: false,
              loadingPayersError: 'Failed to load payer list'
            });
          default:
            return this.setState({
              loadingPayers: false
            });
        }
      }));

      this.setState({
        loadingPaymentList: true
      }, () => getPaymentList().then(res => {
        switch (this.props.payersState.statusCode) {
          case 200:
            return this.setState({
              loadingPaymentList: false,
              loadingPaymentListError: ''
            });
          default:
            return this.setState({
              loadingPaymentList: false,
              loadingPaymentListError: 'Failed to load payment list.'
            });
        }
      }));

      this.setState({
        loadingPaymentList: true
      }, () => getAllPayMethods().then(res => {
        switch (this.props.payMethodsState.statusCode) {
          case 200:
            return this.setState({
              loadingPayMethods: false,
              loadingPayMethodsError: ''
            });
          default:
            return this.setState({
              loadingPayMethods: false,
              loadingPayMethodsError: 'Failed to load payment method list.'
            });
        }
      }));
    } else {
      toDashboard();
    }
  }

  render() {
    const {
      toggleSelection,
      toggleAll,
      isSelected
    } = this;
    const { selectedRow, isNew, selectAll,
      loadingActions } = this.state;
    const checkboxProps = {
      selectAll,
      isSelected,
      toggleSelection,
      toggleAll,
      selectType: 'checkbox',
    };

    if (selectedRow !== undefined || isNew) {
      return (
        this.renderPayerAndPaymentDetails()
      );
    } else {
      const { authState, adminState } = this.props;
      const { loadingPayers, loadingMembers, filterByMemberName, filterByDescription } = this.state;

      return (
        <CommonFeatures
          authState={this.props.authState}
          businessState={this.props.businessState}
        >
          <div className="page-header-row row mt-2 mb-2">
            <div className="col-auto">
              <h3>Payment List</h3>
            </div>
          </div>

          <div className="row pb-2">
            <div className="col-12">
              <SectionPanel
                className="row mt-3 mb-3"
                title="Payments"
                titleAlign="center"
                rightButtonText={cannotWrite(PAYMENT, authState, adminState) ? 'Not Enough Permission' : 'New'}
                rightButtonAction={() => this.setState({
                  activePaymentFilter: 'ALL',
                  isNew: true,
                  memberSearchData: this.mapMemberToSearchData(),
                  payerSearchData: this.mapPayerInfoToSearchData()
                })}
                rightButtonDisabled={
                  cannotWrite(PAYMENT, authState, adminState) ||
                  loadingMembers ||
                  loadingPayers
                }
              >
                <div className="col-auto">
                  <RaisedButton
                    label="ADD FILTER"
                    primary={true}
                    onClick={this.onAddFilterClick}
                    className="float-left mt-4 mb-3"
                  />
                  <div>
                    {this.renderFilters()}
                  </div>
                </div>
                <div
                  className="col-12"
                  style={overlayStyle(!this.state.loadingPaymentList)}
                >
                  {renderOverlayLoading(!this.state.loadingPaymentList, '25%')}
                  <CheckboxTable
                    ref={(r) => this.checkboxTable = r}
                    data={this.generatePaymentsTableData()}
                    columns={[
                      {
                        Header: 'Member Name',
                        accessor: 'memberName',
                        style: { textAlign: 'center' }
                      },
                      {
                        Header: 'Description',
                        accessor: 'description',
                        style: { textAlign: 'center' }
                      },
                      {
                        Header: 'Transactions',
                        accessor: 'numOfTransaction',
                        style: { textAlign: 'center' }
                      },
                      {
                        Header: 'Amount',
                        accessor: 'amountPerTransaction',
                        style: { textAlign: 'center' }
                      },
                      {
                        Header: 'Start Date',
                        accessor: 'startDate',
                        style: { textAlign: 'center' }
                      },
                      {
                        Header: 'Active',
                        accessor: 'active',
                        style: { textAlign: 'center' }
                      }
                    ]}
                    defaultPageSize={20}
                    className="-striped -highlight"
                    keyField={'id'}
                    getTdProps={(state, rowInfo, column, instance) => {
                      return {
                        onClick: (e, handleOriginal) => rowInfo ? this.handleCellClick(rowInfo.index) : null
                      };
                    }}
                    {...checkboxProps}
                  />
                </div>
              </ SectionPanel>
            </div>
          </div>
          {this.renderFilterModal()}
        </CommonFeatures>
      );
    }
  }

  private renderFilters = (): JSX.Element => {
    const { filters } = this.state;

    return (
      <div>
        {filters.map((filter, index) => {
          return (
            <Chip
              key={filter.field + ' ' + filter.operation + ' ' + filter.value}
              onRequestDelete={() => {
                var tempFilters = filters.filter(f => f.field + ' ' + f.operation + ' ' + f.value
                  !== filter.field + ' ' + filter.operation + ' ' + filter.value);
                this.setState({ filters: tempFilters });
              }
              }
              style={{ margin: 4, float: 'left' }}
            >
              {filter.field + ' ' + filter.operation + ' ' + filter.value}
            </Chip>
          );
        })}
      </div>
    );
  }

  private onAddFilterClick = (): void =>
    this.setState({
      openFilterModal: true
    })

  private renderFilterModal = () => {
    if (this.state.openFilterModal) {
      return (
        <Dialog
          title="Add Filter"
          actions={[
            this.renderAddButton(),
            this.renderCloseButton()
          ]}
          modal={true}
          open={this.state.openFilterModal}
          autoScrollBodyContent={true}
        >
          <div className="mr-1">
            <div className="mr-1">
              <SelectField
                floatingLabelText="Field"
                value={this.state.filterField}
                onChange={this.handleFilterFieldChange}
              >
                <MenuItem value={'Member Name'} primaryText={'Member Name'} />
                <MenuItem value={'Payer Name'} primaryText={'Payer Name'} />
                <MenuItem value={'Payment Method'} primaryText={'Payment Method'} />
                <MenuItem value={'Status'} primaryText={'Status'} />
                <MenuItem value={'Continuous'} primaryText={'Continuous'} />
                <MenuItem value={'Description'} primaryText={'Description'} />
                <MenuItem value={'Transactions'} primaryText={'Transactions'} />
                <MenuItem value={'Amount'} primaryText={'Amount'} />

              </SelectField>
            </div>
            <div className="mr-1">
              {this.renderOperationOptions()}
            </div>
            {this.renderFilterValueOptions()}
          </div>

        </Dialog>
      );
    } else {
      return null;
    }
  }

  private renderOperationOptions = () => {

    switch (this.state.filterField) {
      case 'Member Name':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'contains'} primaryText={'Contains'} />
            <MenuItem value={'is'} primaryText={'Is'} />
          </SelectField>
        );
      case 'Payer Name':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'contains'} primaryText={'Contains'} />
            <MenuItem value={'is'} primaryText={'Is'} />
          </SelectField>
        );
      case 'Payment Method':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'is'} primaryText={'Is'} />
          </SelectField>
        );
      case 'Remaining':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'lt'} primaryText={'Less Than'} />
            <MenuItem value={'lte'} primaryText={'Less Than Or Equal To'} />
            <MenuItem value={'eq'} primaryText={'Equal To'} />
            <MenuItem value={'gte'} primaryText={'Greater Than Or Equal To'} />
            <MenuItem value={'gt'} primaryText={'Greater Than'} />
          </SelectField>
        );
      case 'Status':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'is'} primaryText={'Is'} />
          </SelectField>
        );
      case 'Continuous':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'is'} primaryText={'Is'} />
          </SelectField>
        );
      case 'Description':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'contains'} primaryText={'Contains'} />
            <MenuItem value={'is'} primaryText={'Is'} />
          </SelectField>
        );
      case 'Transactions':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'lt'} primaryText={'Less Than'} />
            <MenuItem value={'lte'} primaryText={'Less Than Or Equal To'} />
            <MenuItem value={'eq'} primaryText={'Equal To'} />
            <MenuItem value={'gte'} primaryText={'Greater Than Or Equal To'} />
            <MenuItem value={'gt'} primaryText={'Greater Than'} />
          </SelectField>
        );
      case 'Amount':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'lt'} primaryText={'Less Than'} />
            <MenuItem value={'lte'} primaryText={'Less Than Or Equal To'} />
            <MenuItem value={'eq'} primaryText={'Equal To'} />
            <MenuItem value={'gte'} primaryText={'Greater Than Or Equal To'} />
            <MenuItem value={'gt'} primaryText={'Greater Than'} />
          </SelectField>
        );
      default:
        return (
          null
        );
    }
  }

  private renderFilterValueOptions = () => {

    switch (this.state.filterField) {
      case 'Member Name':
        return (
          <TextField
            fullWidth={true}
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueChange}
          />
        );
      case 'Payer Name':
        return (
          <TextField
            fullWidth={true}
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueChange}
          />
        );
      case 'Payment Method':
        return (
          <SelectField
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueListChange}
          >
            <MenuItem value={'CC'} primaryText={'Credit Card'} />
            <MenuItem value={'EFT'} primaryText={'E.F.T.'} />
            <MenuItem value={'CASH'} primaryText={'Cash'} />
          </SelectField>
        );
      case 'Remaining':
        return (
          <TextField
            fullWidth={true}
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueChange}
          />
        );
      case 'Status':
        return (
          <SelectField
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueListChange}
          >
            <MenuItem value={'all'} primaryText={'All'} />
            <MenuItem value={'active'} primaryText={'Active'} />
            <MenuItem value={'inactive'} primaryText={'Inactive'} />
          </SelectField>
        );
      case 'Continuous':
        return (
          <SelectField
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueListChange}
          >
            <MenuItem value={'yes'} primaryText={'Yes'} />
            <MenuItem value={'no'} primaryText={'No'} />
          </SelectField>
        );
      case 'Description':
        return (
          <TextField
            fullWidth={true}
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueChange}
          />
        );
      case 'Transactions':
        return (
          <TextField
            fullWidth={true}
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueChange}
          />
        );
      case 'Amount':
        return (
          <TextField
            fullWidth={true}
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueChange}
          />
        );
      default:
        return (
          null
        );
    }
  }

  private handleFilterFieldChange = (event: React.SyntheticEvent<{}>, index: number, value: string): void =>
    this.setState({
      filterField: value,
      filterOperation: '',
      filterValue: ''
    })

  private handleFilterOperationChange = (event: React.SyntheticEvent<{}>, index: number, value: string): void =>
    this.setState({
      filterOperation: value,
      filterValue: ''
    })

  private handleFilterValueListChange = (event: React.SyntheticEvent<{}>, index: number, value: string): void =>
    this.setState({ filterValue: value })

  private handleFilterValueChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({
      filterValue: newValue
    })

  private renderAddButton = () => {
    return (
      <RaisedButton
        label="ADD"
        secondary={true}
        keyboardFocused={true}
        className="mr-2"
        onClick={() => {
          var tempFilters = this.state.filters;
          tempFilters.push({
            field: this.state.filterField,
            operation: this.state.filterOperation,
            value: this.state.filterValue
          });
          this.setState({
            openFilterModal: false,
            filters: tempFilters,
            filterField: '',
            filterOperation: '',
            filterValue: ''
          }, this.applyFiltersToPayments);
        }
        }
      />
    );
  }

  private renderCloseButton = () => {
    return (
      <RaisedButton
        label="CLOSE"
        secondary={true}
        keyboardFocused={true}
        className="mr-2"
        onClick={() => this.setState({
          openFilterModal: false,
          filterField: '',
          filterOperation: '',
          filterValue: ''
        })}
      />
    );
  }

  private renderCancelPaymentModal = () => {
    if (this.state.openCancelPaymentModal) {
      return (
        <Dialog
          title="Cancel Payment"
          actions={[
            this.renderCancelPaymentNoButton(),
            this.renderCancelPaymentYesButton()
          ]}
          modal={true}
          open={this.state.openCancelPaymentModal}
          autoScrollBodyContent={true}
        >
          <div>Do you want to cancel the payment?</div>
          {this.state.cancellingPaymentError ?
            <b className="col-auto red">
              {this.state.cancellingPaymentError}
            </b> :
            null
          }
        </Dialog>
      );
    } else {
      return (null);
    }
  }

  private renderCancelPaymentYesButton = () => {
    if (this.state.cancellingPayment) {
      return (
        this.renderLoadingCircle()
      );
    } else {
      return (
        <RaisedButton
          label="Yes"
          primary={true}
          onClick={() => {
            this.setState({
              cancellingPayment: true
            }, () => {
              this.props.cancelMemberPayment(
                this.state.selectedPaymentDetail.id
              ).then(res => {
                switch (this.props.paymentsState.statusCode) {
                  case 200:
                    return this.props.getPaymentList()
                      .then(() => {
                        return this.setState({
                          cancellingPayment: false,
                          cancellingPaymentError: ''
                        }, this.resetAll);
                      });
                  default:
                    return this.setState({
                      cancellingPayment: false,
                      cancellingPaymentError: 'Failed to cancel the payment'
                    });
                }
              });
            });
          }}
        />
      );
    }
  }

  private renderCancelPaymentNoButton = () => {
    return (
      <RaisedButton
        label="No"
        secondary={true}
        keyboardFocused={true}
        className="mr-2"
        onClick={() => this.setState({
          openCancelPaymentModal: false,
          cancellingPaymentError: '',
          cancellingPayment: false
        })}
      />
    );
  }

  private handleCellClick = (index) => {
    const { paymentsState, membersState, payersState, getPaymentDetails } = this.props;

    if (
      paymentsState.paymentList.length > 0 &&
      membersState.members.length > 0 &&
      payersState.payers.length > 0
    ) {
      const payment = this.applyFiltersToPayments()[index];

      if (payment) {
        this.setState({
          loadingPaymentDetails: true,
          payerSearchData: this.mapPayerInfoToSearchData()
        }, () => getPaymentDetails(payment.id).then(res => {
          switch (this.props.paymentsState.statusCode) {
            case 200:
              const payer = payersState.payers.find(p => p.id === payment.payerId);
              return this.props.getMember(payment.memberId)
                .then(() => {
                  const pm = this.props.membersState.member &&
                    this.props.membersState.member.payments.find(p => p.id === payment.id);
                  return this.setState({
                    selectedRow: index,
                    loadingPaymentDetails: false,
                    loadingPaymentDetailsError: '',
                    activePaymentFilter: 'ALL',
                    isNew: false,
                    selectedMember: membersState.members.find(m => m.id === payment.memberId),
                    selectedPayer: payer,
                    selectedPaymentMethod: pm ? pm.paymentMethod : undefined,
                    prevSelectedPaymentMethodType: pm ? pm.paymentMethod.paymentMethodType : '',
                    selectedPaymentDetail: {
                      id: payment.id,
                      newPaymentInfo: {
                        ...DEFAULT_PAYMENT,
                        numberOfTransactions: pm ? pm.numberOfTransactions : 0,
                        term: pm ? pm.term : undefined
                      },
                      downPayment: pm ? pm.downPayment : undefined,
                      total: pm ? pm.total : undefined,
                      amountPerTransaction: pm ? pm.amountPerTransaction : undefined,
                      startDate: pm ? pm.startDate : undefined,
                      payerId: payment.payerId,
                      memberId: payment.memberId,
                      paymentMethodId: payment.paymentMethodId,
                      continuous: pm ? pm.continuous : undefined,
                      description: pm ? pm.description : undefined,
                      schedules: [],
                      // Only for display
                      amountPerTransactionError: '',
                      paymentError: {
                        numOfTransactionError: ''
                      },
                      downPaymentError: '',
                      newPayer: DEFAULT_PAYER,
                      newPayMethod: defaultPaymentMethodWith(PaymentMethod.VOIDCHEQUE),
                      paymentStartDate: {
                        year: pm ? new Date(pm.startDate).getFullYear() : null,
                        month: pm ? new Date(pm.startDate).getMonth() + 1 : null,
                        day: pm ? new Date(pm.startDate).getDate() : null
                      },
                      downPaymentString: pm ? `${pm.downPayment}` : '0.00',
                      amountPerTransactionString: pm ? `${pm.amountPerTransaction}` : '0.00',
                      totalString: pm ? `${pm.total}` : '0.00',
                      // Not a clean way. This is used in member create/update request.
                      newScheduledPayments: pm ? pm.scheduleDetails.map(s => {
                        return {
                          chargeDate: moment(new Date(s.chargeDate)),
                          amount: `${s.amount}`,
                          editableFieldError: '',
                          scheduledPaymentId: s.scheduledPaymentId,
                        };
                      }) :
                        []
                    },
                    scheduledPaymentsForUpdate: pm ? pm.scheduleDetails.map(s => {
                      return {
                        chargeDate: moment(new Date(s.chargeDate)),
                        newChargeDate: moment(new Date(s.chargeDate)),
                        amount: `${s.amount}`,
                        newAmount: `${s.amount}`,
                        editableFieldError: '',
                        scheduledPaymentId: s.scheduledPaymentId,
                      };
                    }) :
                      []
                  });
                });
            default:
              return this.setState({
                loadingPaymentDetails: false,
                loadingPaymentDetailsError: 'Failed to load payment details'
              });
          }
        }));
      }
    }
  }

  private generatePaymentsTableData = () => {
    const { paymentsState, membersState } = this.props;
    const { activePaymentFilter, filterByDescription, filterByMemberName } = this.state;

    return this.applyFiltersToPayments().map((p: Payment) => {
      const member = membersState.members.find(m => m.id === p.memberId);

      return {
        id: p.id,
        memberName: member ? member.firstName + ' ' + member.lastName : '',
        description: p.description,
        numOfTransaction: p.numberOfTransactions,
        amountPerTransaction: <FormattedNumber value={p.amountPerTransaction} style="currency" currency="USD" />,
        startDate: moment(new Date(p.startDate)).format('MMM Do YY'),
        active: p.active ? 'YES' : 'NO'
      };
    });
  }

  private applyFiltersToPayments = () => {
    const { paymentsState, membersState, payersState, payMethodsState } = this.props;
    const { filters } = this.state;

    if (filters.length === 0) {
      return paymentsState.paymentList;
    }

    var filtered = [];
    paymentsState.paymentList.forEach((p: Payment) => {
      var match = 0;
      filters.forEach((f: Filter) => {
        switch (f.field) {
          case 'Member Name':
            var member = membersState.members.find((m: Member) => m.id === p.memberId);
            if (member) {
              match += this.applySingleFilter(f, member.firstName + ' ' + member.lastName);
            } else {
              match += 1;
            }
            break;
          case 'Payer Name':
            var found = payersState.payers.find((payer: PayerInfo) => payer.id === p.payerId);
            if (found) {
              match += this.applySingleFilter(f, found.firstName + ' ' + found.lastName);
            } else {
              match += 1;
            }
            break;
          case 'Payment Method':
            var payMethod =
              payMethodsState.payMethods.find((pm: PayMethodsInfo) => p.paymentMethodId === pm.id);
            if (payMethod) {
              match += this.applySingleFilter(f, payMethod.paymentMethodType === 'CREDITCARD' ? 'cc' :
                payMethod.paymentMethodType === 'VOIDCHEQUE' ? 'eft' : 'cash');
            } else {
              match += 1;
            }
            break;
          case 'Remaining':
            match += this.applySingleFilter(f, p.numberOfTransactions);
            break;
          case 'Status':
            match += this.applySingleFilter(f, p.active ? 'active' : 'inactive');
            break;
          case 'Continuous':
            match += this.applySingleFilter(f, p.continuous ? 'yes' : 'no');
            break;
          case 'Description':
            match += this.applySingleFilter(f, p.description);
            break;
          case 'Transactions':
            match += this.applySingleFilter(f, p.numberOfTransactions);
            break;
          case 'Amount':
            match += this.applySingleFilter(f, p.amountPerTransaction);
            break;
          default:
            match += 1;
            break;
        }
      });
      if (match === 0) {
        filtered.push(p);
      }
    });

    return filtered;
  }

  private applySingleFilter = (filter: Filter, value: any): number => {

    var match = false;
    switch (filter.operation) {
      case 'lt':
        match = Number(filter.value) > Number(value);
        break;
      case 'lte':
        match = Number(filter.value) >= Number(value);
        break;
      case 'eq':
        match = Number(filter.value) === Number(value);
        break;
      case 'gte':
        match = Number(filter.value) <= Number(value);
        break;
      case 'gt':
        match = Number(filter.value) < Number(value);
        break;
      case 'is':
        match = String(value).toLocaleLowerCase() === String(filter.value).toLocaleLowerCase();
        break;
      case 'contains':
        match = String(value).toLocaleLowerCase().includes(String(filter.value).toLocaleLowerCase());
        break;
      default:
        break;
    }

    return match ? 0 : 1;
  }

  private handleActivePaymentChange = (event: React.SyntheticEvent<{}>, index: number, value: string): void =>
    this.setState({ activePaymentFilter: value })

  private handleFilterByMemberNameChange = (e: React.FormEvent<{}>, newValue: string): void =>
    this.setState({ filterByMemberName: newValue })

  private handleFilterByDescriptionChange = (e: React.FormEvent<{}>, newValue: string): void =>
    this.setState({ filterByDescription: newValue })

  private renderPayerAndPaymentDetails = (): JSX.Element => {
    const { authState, adminState } = this.props;
    const {
      selectedPayer,
      selectedPaymentMethod,
      loadingDeletePayMethod,
      deletingPayMethodError,
      isPayerDisplayMode,
      creatingPayment,
      cancellingPayment,
      cancellingPaymentError,
      isNew,
      createPaymentError,
      selectedRow
    } = this.state;

    return (
      <CommonFeatures
        authState={this.props.authState}
        businessState={this.props.businessState}
      >
        <div className="page-header-row row mt-2 mb-2">
          <div className="col-auto">
            <h3>Payment List</h3>
          </div>
        </div>

        <div className="row pb-2">
          <div className="col-6">
            <Accordion accordion={false}>
              <AccordionItem expanded={true}>
                <AccordionItemTitle>
                  <h4 className="u-position-relative">
                    <b>Payer</b>
                    <div className="accordion__arrow" role="presentation" />
                  </h4>
                </AccordionItemTitle>
                <AccordionItemBody>
                  <div className="row align-items-center justify-content-center">
                    <div className="col-9 align-self-center text-center">
                      {this.renderSearchForPayerInput()}
                    </div>
                    <div className="col-auto">
                      <FloatingActionButton
                        mini={true}
                        onClick={() => this.setState({
                          openPayerModal: true,
                          isPayerDisplayMode: false,
                          isPayerEditMode: false,
                          selectedPayer: undefined,
                          payerSearchText: '',
                          selectedPaymentMethod: undefined
                        })}
                        disabled={cannotWrite(PAYMENT, authState, adminState) || !isNew}
                      >
                        <ContentAdd />
                      </FloatingActionButton>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      {selectedPayer ?
                        isPayerDisplayMode ? this.renderPayerForm() : this.renderUpdatingPayerForm() :
                        null
                      }
                      {selectedPayer ? this.renderPayingMembers() : null}
                    </div>
                  </div>
                </AccordionItemBody>
              </AccordionItem>
              <AccordionItem expanded={true}>
                <AccordionItemTitle>
                  <h4 className="u-position-relative">
                    <b>Payment Method</b>
                    <div className="accordion__arrow" role="presentation" />
                  </h4>
                </AccordionItemTitle>
                <AccordionItemBody>
                  <div className="row align-items-center justify-content-center">
                    <div className="col-9 align-self-center text-center">
                      {this.renderPaymentMethodSelect()}
                    </div>
                    <div className="col-auto">
                      <FloatingActionButton
                        mini={true}
                        onClick={() => this.setState({
                          openNewPaymentMethodModal: true,
                          isPaymentMethodDisplayMode: false,
                          isPaymentMethodEditMode: false,
                          selectedPaymentMethod: undefined,
                          deletingPayMethodError: ''
                        })}
                        disabled={cannotWrite(PAYMENT, authState, adminState) || !selectedPayer}
                      >
                        <ContentAdd />
                      </FloatingActionButton>
                    </div>
                    {selectedPaymentMethod ?
                      <div className="col-auto">
                        <RaisedButton
                          label={cannotUpdate(PAYMENT, authState, adminState) ?
                            'Not Enough Permission' :
                            'Delete'
                          }
                          secondary={true}
                          onClick={() => this.handlePaymentMethodDelete()}
                          disabled={cannotUpdate(PAYMENT, authState, adminState) || loadingDeletePayMethod || !isNew}
                        />
                      </div> :
                      null
                    }
                  </div>
                  {deletingPayMethodError ?
                    <div className="row">
                      <b className="col-12 red text-center">{deletingPayMethodError}</b>
                    </div> :
                    null
                  }
                  {selectedPaymentMethod ?
                    this.renderPayMethodForm() :
                    null
                  }
                </AccordionItemBody>
              </AccordionItem>
              <AccordionItem expanded={true}>
                <AccordionItemTitle>
                  <h4 className="u-position-relative">
                    <b>Payment Detail</b>
                    <div className="accordion__arrow" role="presentation" />
                  </h4>
                </AccordionItemTitle>
                <AccordionItemBody>
                  {this.renderPaymentDetail()}
                </AccordionItemBody>
              </AccordionItem>
            </Accordion>
          </div>
          <div className="col-6">
            {this.renderRightSideAccordion()}
            <div className="row justify-content-end mt-3">
              {createPaymentError ?
                <b className="col-auto red">
                  {createPaymentError}
                </b> :
                null
              }
              <div className="col-auto">
                <RaisedButton
                  label="Close"
                  secondary={true}
                  keyboardFocused={true}
                  onClick={() => this.resetAll()}
                  disabled={creatingPayment}
                />
              </div>
              <div className="col-auto">
                {cancellingPayment ?
                  this.renderLoadingCircle() :
                  !isNew && selectedRow !== undefined && this.applyFiltersToPayments()[selectedRow] &&
                    (this.applyFiltersToPayments()[selectedRow].active ||
                      (selectedPaymentMethod && selectedPaymentMethod.paymentMethodType === PaymentMethod.CASH)) ?
                    <RaisedButton
                      label={'Cancel Payment'}
                      primary={true}
                      onClick={() => this.setState({ openCancelPaymentModal: true })}
                    /> :
                    null
                }
              </div>
              <div className="col-auto">
                {creatingPayment ?
                  this.renderLoadingCircle() :
                  <RaisedButton
                    label={'Submit'}
                    primary={true}
                    disabled={this.isRequestIncomplete()}
                    onClick={() => isNew ?
                      this.handleCreatePayment() :
                      this.handleUpdatePayment()
                    }
                  />
                }
              </div>
            </div>
          </div>
        </div>
        {this.renderNewPayerModal()}
        {this.renderNewPayMethodModal()}
        {this.renderCancelPaymentModal()}
      </CommonFeatures>
    );
  }

  private isRequestIncomplete = (): boolean => {
    const {
      selectedMember,
      selectedPayer,
      selectedPaymentDetail,
      selectedPaymentMethod
    } = this.state;

    return !selectedMember ||
      !selectedPayer ||
      !selectedPaymentMethod ||
      this.doesErrorExistInPayMethodReq() ||
      this.doesErrorExistInPayerReq() ||
      (selectedPaymentDetail.amountPerTransactionError &&
        selectedPaymentDetail.amountPerTransactionError !== '') ||
      (selectedPaymentDetail.descriptionError &&
        selectedPaymentDetail.descriptionError !== '') ||
      (selectedPaymentDetail.downPaymentError &&
        selectedPaymentDetail.downPaymentError !== '') ||
      (selectedPaymentDetail.paymentError &&
        selectedPaymentDetail.paymentError.numOfTransactionError !== '') ||
      (selectedPaymentDetail.newScheduledPayments
        .filter(s => s.editableFieldError !== '').length > 0
      );
  }

  private resetAll = () => {
    mmsStore.dispatch({
      type: REMOVE_RIDIRECT_FROM_MEMBER
    });

    mmsStore.dispatch({
      type: REMOVE_PAYMENT_DETAILS
    });

    this.setState({
      checkedSameAsMember: false,
      payerSearchText: '',
      memberSearchText: '',
      payerSearchData: [],
      memberSearchData: [],
      loadingPayers: false,
      loadingPayersError: '',
      openPayerModal: false,
      payerRequest: undefined,
      newPayerRequestError: undefined,
      isPayerDisplayMode: true,
      loadingCreatePayer: false,
      newPayer: undefined,
      creatingPayerError: '',
      isPayerEditMode: false,
      loadingUpdatePayer: false,
      loadingMembers: false,
      loadingMembersError: '',
      openNewPaymentMethodModal: false,
      isPaymentMethodDisplayMode: true,
      isPaymentMethodEditMode: false,
      loadingPayMethods: false,
      loadingPayMethodsError: '',
      updatingPayerError: '',
      loadingDeletePayMethod: false,
      deletingPayMethodError: '',
      creatingPayMethodError: '',
      loadingCreatePayMethod: false,
      payMethodRequest: {
        payMethodType: PaymentMethod.VOIDCHEQUE
      },
      selectedPaymentDetail: this.resetSelectedPaymentDetail(this.props),
      selectedPayer: undefined,
      selectedPaymentMethod: undefined,
      isPaymentDetailDisplayMode: false,
      scheduledPaymentsForUpdate: [],
      creatingPayment: false,
      createPaymentError: '',
      selectedMember: undefined,
      selectedRow: undefined,
      isNew: false,
      loadingPaymentList: false,
      loadingPaymentListError: '',
      loadingPaymentDetails: false,
      loadingPaymentDetailsError: '',
      filterByMemberName: '',
      filterByDescription: '',
      cancellingPayment: false,
      cancellingPaymentError: '',
      openCancelPaymentModal: false,
      prevSelectedPaymentMethodType: ''
    });
  }

  private renderRightSideAccordion = (): JSX.Element => {
    const { paymentsState } = this.props;
    const { selectedPaymentDetail, scheduledPaymentsForUpdate, isPaymentDetailDisplayMode, isNew } = this.state;

    return (
      <Accordion accordion={false}>
        <AccordionItem expanded={true}>
          <AccordionItemTitle>
            <h4 className="u-position-relative">
              <b>Member</b>
              <div className="accordion__arrow" role="presentation" />
            </h4>
          </AccordionItemTitle>
          <AccordionItemBody>
            <div className="row align-items-center justify-content-center">
              <div className="col-9 align-self-center text-center">
                {this.renderSearchForMemberInput()}
              </div>
            </div>
          </AccordionItemBody>
        </AccordionItem>
        <AccordionItem expanded={true}>
          <AccordionItemTitle>
            <h4 className="u-position-relative">
              <b>Schedule</b>
              <div className="accordion__arrow" role="presentation" />
            </h4>
          </AccordionItemTitle>
          <AccordionItemBody>
            <div className="row">
              <div className="col-12">
                <ReactTable
                  data={selectedPaymentDetail && selectedPaymentDetail.newScheduledPayments ?
                    selectedPaymentDetail.newScheduledPayments.map(s => {
                      return { chargeDate: s.chargeDate, amount: s.amount };
                    }) :
                    []
                  }
                  columns={isNew ?
                    [
                      {
                        Header: 'Charge Date',
                        accessor: 'chargeDate',
                        Cell: (cellInfo) => this.renderChargeDateEditable(
                          cellInfo,
                          selectedPaymentDetail && selectedPaymentDetail.newScheduledPayments,
                          isNew
                        ),
                        style: { textAlign: 'center' }
                      },
                      {
                        Header: 'Amount',
                        accessor: 'amount',
                        Cell: (cellInfo) => this.renderAmountEditable(
                          cellInfo,
                          selectedPaymentDetail && selectedPaymentDetail.newScheduledPayments,
                          isNew
                        ),
                        style: { textAlign: 'center' }
                      }
                    ] :
                    [
                      {
                        Header: 'Charge Date',
                        accessor: 'chargeDate',
                        Cell: (cellInfo) => this.renderChargeDateEditable(
                          cellInfo,
                          scheduledPaymentsForUpdate,
                          isNew
                        ),
                        style: { textAlign: 'center' }
                      },
                      {
                        Header: 'Amount',
                        accessor: 'amount',
                        Cell: (cellInfo) => this.renderAmountEditable(
                          cellInfo,
                          scheduledPaymentsForUpdate,
                          isNew
                        ),
                        style: { textAlign: 'center' }
                      },
                      {
                        Header: 'Update',
                        accessor: 'update',
                        Cell: (cellInfo) => this.renderUpdateButton(
                          cellInfo,
                          scheduledPaymentsForUpdate,
                          isNew
                        ),
                        style: { textAlign: 'center' }
                      }
                    ]
                  }
                  defaultPageSize={5}
                  className="-striped -highlight"
                />
              </div>
            </div>
            {
              selectedPaymentDetail &&
                selectedPaymentDetail.newScheduledPayments &&
                selectedPaymentDetail.newScheduledPayments.find(s => s.editableFieldError !== '') ?
                <div className="row">
                  <div className="col-12 red">
                    One or more fields have invalid value. Please check all fields again.
                  </div>
                </div> :
                null
            }
          </AccordionItemBody>
        </AccordionItem>
        {isNew ?
          null :
          <AccordionItem expanded={true}>
            <AccordionItemTitle>
              <h4 className="u-position-relative">
                <b>Payment History</b>
                <div className="accordion__arrow" role="presentation" />
              </h4>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div className="row">
                <div className="col-12">
                  <ReactTable
                    data={paymentsState.paymentDetails &&
                      paymentsState.paymentDetails.paymentHistories &&
                      paymentsState.paymentDetails.paymentHistories.length > 0 ?
                      paymentsState.paymentDetails.paymentHistories.map(p => {
                        return {
                          amount: p.amount,
                          chargedDate: moment(new Date(p.chargedDate)).format('MMM Do YY'),
                          paymentStatus: this.getTextValueOfPaymentStatus(p.paymentStatus)
                        };
                      }) :
                      []
                    }
                    columns={[
                      {
                        Header: 'Charged Date',
                        accessor: 'chargedDate',
                        style: { textAlign: 'center' }
                      },
                      {
                        Header: 'Amount',
                        accessor: 'amount',
                        style: { textAlign: 'center' }
                      },
                      {
                        Header: 'Status',
                        accessor: 'paymentStatus',
                        style: { textAlign: 'center' }
                      }
                    ]}
                    defaultPageSize={5}
                    className="-striped -highlight"
                  />
                </div>
              </div>
            </AccordionItemBody>
          </AccordionItem>
        }
      </Accordion>
    );
  }

  private handleCreatePayment = () => {
    const {
      selectedMember,
      selectedPayer,
      selectedPaymentMethod,
      selectedPaymentDetail
    } = this.state;

    if (selectedMember && selectedPayer && selectedPaymentMethod && selectedPaymentDetail) {
      this.setState(
        { creatingPayment: true },
        () => this.props.createPayment(
          selectedPaymentDetail.id,
          selectedPaymentDetail.newPaymentInfo.paymentType,
          selectedPaymentDetail.downPayment,
          selectedPaymentDetail.total,
          selectedPaymentDetail.amountPerTransaction,
          selectedPaymentDetail.newPaymentInfo.currency,
          selectedPaymentDetail.newPaymentInfo.term,
          selectedPaymentDetail.newPaymentInfo.numberOfTransactions,
          new Date(
            selectedPaymentDetail.paymentStartDate.year,
            selectedPaymentDetail.paymentStartDate.month - 1,
            selectedPaymentDetail.paymentStartDate.day
          ).getTime(),
          selectedPayer.id,
          selectedMember.id,
          selectedPaymentMethod.id,
          selectedPaymentDetail.continuous,
          selectedPaymentDetail.newScheduledPayments.map(s => {
            return {
              scheduledPaymentId: s.scheduledPaymentId ? s.scheduledPaymentId : DEFAULT_PAYMENT.id,
              chargeDate: s.chargeDate.valueOf(),
              amount: parseFloat(s.amount),
              status: s.status
            };
          }),
          selectedPaymentDetail.description
        )
          .then(res => {
            switch (this.props.membersState.statusCode) {
              case 200:
                return this.props.getPaymentList().then(() => this.resetAll());
              case 400:
                return this.setState({
                  creatingPayment: false,
                  createPaymentError: 'Failed to create new payment'
                });
              case 404:
                return this.setState({
                  creatingPayment: false,
                  createPaymentError: 'Failed to create new payment'
                });
              case 409:
                return this.setState({
                  creatingPayment: false,
                  createPaymentError: 'Failed to create new payment'
                });
              case 406:
                return this.setState({
                  creatingPayment: false,
                  createPaymentError: 'Failed to create new payment'
                });
              case 417:
                return this.setState({
                  creatingPayment: false,
                  createPaymentError: 'Failed to create new payment. Please check start date and other inputs.'
                });
              default:
                return this.setState({
                  creatingPayment: false
                });
            }
          })
      );
    }
  }

  private handleUpdatePayment = () => {
    const {
      selectedMember,
      selectedPayer,
      selectedPaymentMethod,
      selectedPaymentDetail
    } = this.state;

    if (selectedMember && selectedPayer && selectedPaymentMethod && selectedPaymentDetail) {
      this.setState(
        { creatingPayment: true },
        () => this.props.updatePayment(
          selectedPaymentDetail.id,
          selectedPayer.id,
          selectedPaymentMethod.id,
          selectedPaymentDetail.continuous,
          selectedPaymentDetail.amountPerTransaction,
          selectedPaymentDetail.newScheduledPayments.map(s => {
            return {
              scheduledPaymentId: s.scheduledPaymentId ? s.scheduledPaymentId : DEFAULT_PAYMENT.id,
              chargeDate: s.chargeDate.valueOf(),
              amount: parseFloat(s.amount),
              status: s.status
            };
          }),
          selectedPaymentDetail.description
        )
          .then(res => {
            switch (this.props.membersState.statusCode) {
              case 200:
                return this.props.getPaymentList().then(() => this.resetAll());
              case 400:
                return this.setState({
                  creatingPayment: false,
                  createPaymentError: 'Failed to create new payment'
                });
              case 404:
                return this.setState({
                  creatingPayment: false,
                  createPaymentError: 'Failed to create new payment'
                });
              case 409:
                return this.setState({
                  creatingPayment: false,
                  createPaymentError: 'Failed to create new payment'
                });
              case 406:
                return this.setState({
                  creatingPayment: false,
                  createPaymentError: 'Failed to create new payment'
                });
              case 417:
                return this.setState({
                  creatingPayment: false,
                  createPaymentError: 'Failed to create new payment. Please check start date and other inputs.'
                });
              default:
                return this.setState({
                  creatingPayment: false
                });
            }
          })
      );
    }
  }

  private renderPaymentDetail = (): JSX.Element => {
    const {
      selectedPayer,
      selectedPaymentMethod,
      selectedPaymentDetail,
      isPaymentDetailDisplayMode,
      isNew
    } = this.state;
    const { authState, adminState } = this.props;

    if (selectedPayer && selectedPaymentMethod) {
      return (
        <div>
          <div className="row">
            <div className="col-6">
              <TextField
                fullWidth={true}
                floatingLabelText="Description"
                errorText={selectedPaymentDetail ? selectedPaymentDetail.descriptionError : null}
                value={selectedPaymentDetail ? selectedPaymentDetail.description : null}
                onChange={this.onDescriptionChange}
                disabled={
                  cannotWrite(PAYMENT, authState, adminState) || isPaymentDetailDisplayMode || !isNew
                }
                style={!isNew ? fieldStyles.rootStyle : {}}
                inputStyle={!isNew ? fieldStyles.textStyle : {}}
                floatingLabelStyle={!isNew ? fieldStyles.textStyle : {}}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <TextField
                className="material-input-required-red"
                fullWidth={true}
                floatingLabelText="Amount Per Transaction"
                errorText={selectedPaymentDetail ? selectedPaymentDetail.amountPerTransactionError : null}
                value={selectedPaymentDetail ? selectedPaymentDetail.amountPerTransactionString : null}
                onChange={this.onAmountPerTransactionChange}
                disabled={
                  cannotWrite(PAYMENT, authState, adminState) || isPaymentDetailDisplayMode || !isNew
                }
                onFocus={() => selectedPaymentDetail &&
                  selectedPaymentDetail.amountPerTransactionString &&
                  selectedPaymentDetail.amountPerTransactionString.trim() === '0.00' ?
                  this.onAmountPerTransactionChange(undefined, '') :
                  undefined
                }
                style={!isNew ? fieldStyles.rootStyle : {}}
                inputStyle={!isNew ? fieldStyles.textStyle : {}}
                floatingLabelStyle={!isNew ? fieldStyles.textStyle : {}}
              />
            </div>
            <div className="col-6">
              <SelectField
                className="material-input-required-red"
                fullWidth={true}
                floatingLabelText={CURRENCY_FIELD_LABEL}
                value={selectedPaymentDetail && selectedPaymentDetail.newPaymentInfo ?
                  selectedPaymentDetail.newPaymentInfo.currency : null}
                onChange={this.onCurrencyChange}
                disabled={
                  cannotWrite(PAYMENT, authState, adminState) || isPaymentDetailDisplayMode || !isNew
                }
                style={!isNew ? fieldStyles.rootStyle : {}}
                floatingLabelStyle={!isNew ? fieldStyles.textStyle : {}}
              >
                {
                  currencyList.map((currency, index) => {
                    return <MenuItem key={index} value={currency} primaryText={currency} />;
                  })
                }
              </SelectField>
            </div>
          </div>
          <div className="row">
            <div className="col-4">
              <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                <SelectField
                  className="material-input-required-red"
                  fullWidth={true}
                  floatingLabelText={'Start Year'}
                  value={selectedPaymentDetail && selectedPaymentDetail.paymentStartDate ?
                    selectedPaymentDetail.paymentStartDate.year : null}
                  onChange={this.onStartDateYearChange}
                  disabled={
                    cannotWrite(PAYMENT, authState, adminState) || isPaymentDetailDisplayMode || !isNew
                  }
                  style={!isNew ? fieldStyles.rootStyle : {}}
                  floatingLabelStyle={!isNew ? fieldStyles.textStyle : {}}
                >
                  {
                    filteredYear()
                      .map((year: number, index: number) => {
                        return (
                          <MenuItem key={index} value={year} primaryText={year} />
                        );
                      })
                  }
                  {
                    selectedPaymentDetail &&
                      selectedPaymentDetail.paymentStartDate &&
                      filteredYear().includes(selectedPaymentDetail.paymentStartDate.year) ?
                      undefined :
                      <MenuItem
                        value={selectedPaymentDetail.paymentStartDate.year}
                        primaryText={selectedPaymentDetail.paymentStartDate.year}
                      />
                  }
                </SelectField>
              </div>
            </div>
            <div className="col-4">
              <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                <SelectField
                  className="material-input-required-red"
                  fullWidth={true}
                  floatingLabelText={'Start Month'}
                  value={selectedPaymentDetail && selectedPaymentDetail.paymentStartDate ?
                    selectedPaymentDetail.paymentStartDate.month : null}
                  onChange={this.onStartDateMonthChange}
                  disabled={
                    cannotWrite(PAYMENT, authState, adminState) || isPaymentDetailDisplayMode || !isNew
                  }
                  style={!isNew ? fieldStyles.rootStyle : {}}
                  floatingLabelStyle={!isNew ? fieldStyles.textStyle : {}}
                >
                  {renderStartMonthOptions(
                    isNew,
                    selectedPaymentDetail ? selectedPaymentDetail.paymentStartDate.year : null,
                    selectedPaymentDetail ? selectedPaymentDetail.paymentStartDate.month : null,
                  )}
                </SelectField>
              </div>
            </div>
            <div className="col-4">
              <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                <SelectField
                  className="material-input-required-red"
                  fullWidth={true}
                  floatingLabelText={'Start Day'}
                  value={selectedPaymentDetail && selectedPaymentDetail.paymentStartDate ?
                    selectedPaymentDetail.paymentStartDate.day ?
                      selectedPaymentDetail.paymentStartDate.day : 1 :
                    null}
                  onChange={this.onStartDateDayChange}
                  disabled={
                    cannotWrite(PAYMENT, authState, adminState) || isPaymentDetailDisplayMode || !isNew
                  }
                  style={!isNew ? fieldStyles.rootStyle : {}}
                  floatingLabelStyle={!isNew ? fieldStyles.textStyle : {}}
                >
                  {
                    selectedPaymentMethod.paymentMethodType === 'CREDITCARD' ?
                      THIRTY_DAYS_MONTH.includes(selectedPaymentDetail.paymentStartDate.month) ?
                        THIRTY_DAYS.map((value: number, index: number) => {
                          return (<MenuItem key={index} value={value} primaryText={value} />);
                        }) :
                        selectedPaymentDetail.paymentStartDate.month === 2 ?
                          this.isLeapYear(selectedPaymentDetail.paymentStartDate.year) ?
                            TWENTY_NINE_DAYS.map((value: number, index: number) => {
                              return (<MenuItem key={index} value={value} primaryText={value} />);
                            }) :
                            TWENTY_EIGHT_DAYS.map((value: number, index: number) => {
                              return (<MenuItem key={index} value={value} primaryText={value} />);
                            })
                          :
                          THIRTY_ONE_DAYS.map((value: number, index: number) => {
                            return (<MenuItem key={index} value={value} primaryText={value} />);
                          })
                      :
                      PAYMENT_START_DAYS.map((value: number, index: number) => {
                        return (<MenuItem key={index} value={value} primaryText={value} />);
                      })
                  }
                  {
                    renderExtraPaymentStartDayMenuItem(
                      isPaymentDetailDisplayMode,
                      selectedPaymentDetail ? selectedPaymentDetail.paymentStartDate.day : null,
                      selectedPaymentMethod.paymentMethodType ? selectedPaymentMethod.paymentMethodType
                        : null
                    )
                  }
                </SelectField>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-4" style={{ paddingRight: 0 }}>
              <TextField
                className="material-input-required-red"
                fullWidth={true}
                floatingLabelText="Num of Transaction"
                value={selectedPaymentDetail && selectedPaymentDetail.newPaymentInfo ?
                  selectedPaymentDetail.newPaymentInfo.numberOfTransactions : null}
                onChange={this.onNumberOfTransactionsChange}
                errorText={selectedPaymentDetail ? selectedPaymentDetail.paymentError.numOfTransactionError : ''}
                disabled={
                  cannotWrite(PAYMENT, authState, adminState) ||
                  !isNew ||
                  isPaymentDetailDisplayMode ||
                  (selectedPaymentMethod &&
                    selectedPaymentMethod.paymentMethodType &&
                    selectedPaymentMethod.paymentMethodType === PaymentMethod.CASH)
                }
                style={!isNew ? fieldStyles.rootStyle : {}}
                inputStyle={!isNew ? fieldStyles.textStyle : {}}
                floatingLabelStyle={!isNew ? fieldStyles.textStyle : {}}
              />
            </div>
            <div className="col-2 pt-3" style={{ paddingLeft: 0 }}>
              <div className="row">
                <div
                  className="col-12"
                  style={{
                    fontSize: 10,
                    color: cannotWrite(PAYMENT, authState, adminState) ?
                      'grey' :
                      'black'
                  }}
                >
                  Continuous
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <Checkbox
                    checked={selectedPaymentDetail ? selectedPaymentDetail.continuous : false}
                    onCheck={this.onContinuousPaymentChange}
                    disabled={
                      cannotWrite(PAYMENT, authState, adminState) ||
                      (selectedPaymentMethod &&
                        selectedPaymentMethod.paymentMethodType &&
                        selectedPaymentMethod.paymentMethodType === PaymentMethod.CASH)
                    }
                    style={!isNew ? fieldStyles.rootStyle : {}}
                    inputStyle={!isNew ? fieldStyles.textStyle : {}}
                    labelPosition={'left'}
                  />
                </div>
              </div>
            </div>
            <div className="col-6">
              <SelectField
                className="material-input-required-red"
                fullWidth={true}
                floatingLabelText="Term"
                floatingLabelFixed={true}
                value={selectedPaymentDetail ? selectedPaymentDetail.newPaymentInfo.term : null}
                onChange={this.onTermChange}
                disabled={
                  cannotWrite(PAYMENT, authState, adminState) ||
                  !isNew ||
                  isPaymentDetailDisplayMode
                }
              >
                {
                  selectedPaymentMethod.paymentMethodType === 'CREDITCARD' ?
                    paymentTermsCC.map((paymentTerm, index) => {
                      return <MenuItem key={index} value={paymentTerm.code} primaryText={paymentTerm.name} />;
                    })
                    :
                    paymentTerms.map((paymentTerm, index) => {
                      return <MenuItem key={index} value={paymentTerm.code} primaryText={paymentTerm.name} />;
                    })
                }
              </SelectField>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <TextField
                className="material-input-required-red"
                fullWidth={true}
                floatingLabelText="Down Payment"
                value={selectedPaymentDetail ? selectedPaymentDetail.downPaymentString : null}
                disabled={
                  cannotWrite(PAYMENT, authState, adminState) ||
                  !isNew ||
                  isPaymentDetailDisplayMode
                }
                onChange={this.onDownPaymentChange}
                onFocus={() => selectedPaymentDetail && selectedPaymentDetail.downPaymentString.trim() === '0.00' ?
                  this.onDownPaymentChange(undefined, '') :
                  undefined
                }
                errorText={
                  selectedPaymentDetail ?
                    selectedPaymentDetail.downPaymentString === '' || !(
                      validator.isNumeric(selectedPaymentDetail.downPaymentString) ||
                      validator.isFloat(selectedPaymentDetail.downPaymentString)
                    ) || !(
                      selectedPaymentDetail.downPaymentString.includes('.') ?
                        (
                          selectedPaymentDetail.downPaymentString.split('.')[1].length !== 0 &&
                          selectedPaymentDetail.downPaymentString.split('.')[1].length <= 2
                        ) :
                        true
                    ) ? 'Enter valid amount' : '' :
                    ''
                }
              />
            </div>
            <div className="col-6">
              <TextField
                fullWidth={true}
                floatingLabelText="Total Amount"
                value={selectedPaymentDetail ? selectedPaymentDetail.total : '0.00'}
                disabled={true}
              />
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <b>Select payer and payment method first</b>
      );
    }
  }

  private renderChargeDateEditable = (cellInfo, scheduledPayments, isNew) => {
    const { selectedPaymentMethod } = this.state;

    return (
      <ReactDatePicker
        selected={scheduledPayments ?
          isNew ? scheduledPayments[cellInfo.index].chargeDate : scheduledPayments[cellInfo.index].newChargeDate :
          null
        }
        onChange={(date) => this.handleChargeDateChange(date, cellInfo, isNew)}
        disabled={
          (selectedPaymentMethod && selectedPaymentMethod.paymentMethodType === PaymentMethod.CASH) ||
          (isNew && cannotUpdate(PAYMENT, this.props.authState, this.props.adminState))
        }
      />
    );
  }

  private isLeapYear = (year: number): boolean => {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 100 === 0 && year % 400 !== 0) || year % 400 === 0;
  }

  private handleChargeDateChange = (date, cellInfo, isNew) => {
    if (isNew) {
      this.setState((prevState) => ({
        selectedPaymentDetail: {
          ...prevState.selectedPaymentDetail,
          newScheduledPayments: prevState.selectedPaymentDetail &&
            prevState.selectedPaymentDetail.newScheduledPayments ?
            [
              ...prevState.selectedPaymentDetail.newScheduledPayments.slice(0, cellInfo.index),
              {
                ...prevState.selectedPaymentDetail.newScheduledPayments[cellInfo.index],
                chargeDate: date,
                status: CREATED
              },
              ...prevState.selectedPaymentDetail.newScheduledPayments.slice(cellInfo.index + 1)
            ] :
            []
        }
      }));
    } else {
      return this.setState((prevState) => ({
        scheduledPaymentsForUpdate: [
          ...prevState.scheduledPaymentsForUpdate.slice(0, cellInfo.index),
          {
            ...prevState.scheduledPaymentsForUpdate[cellInfo.index],
            newChargeDate: date
          },
          ...prevState.scheduledPaymentsForUpdate.slice(cellInfo.index + 1)
        ]
      }));
    }
  }

  private renderUpdateButton = (cellInfo, scheduledPayments, isNew) => {
    const { authState, adminState } = this.props;

    if (scheduledPayments.length > 0) {
      return (
        <FlatButton
          label={cannotUpdate(PAYMENT, authState, adminState) ?
            'NOT ENOUGH PERMISSION' :
            ''
          }
          icon={cannotUpdate(PAYMENT, authState, adminState) ?
            null :
            <CheckCircle />}
          disabled={isNew ||
            cannotUpdate(PAYMENT, authState, adminState) ||
            ((scheduledPayments[cellInfo.index].newAmount &&
              scheduledPayments[cellInfo.index].editableFieldError === '' ?
              scheduledPayments[cellInfo.index].amount ===
              scheduledPayments[cellInfo.index].newAmount :
              true) &&
              (scheduledPayments[cellInfo.index].newChargeDate ?
                scheduledPayments[cellInfo.index].chargeDate.valueOf() ===
                scheduledPayments[cellInfo.index].newChargeDate.valueOf() :
                true))
          }
          onClick={() => {
            if (cannotUpdate(PAYMENT, authState, adminState)) {
              return null;
            } else {
              if (
                scheduledPayments &&
                scheduledPayments[cellInfo.index].scheduledPaymentId &&
                scheduledPayments[cellInfo.index].editableFieldError === ''
              ) {
                this.props.updateScheduledPayment(
                  scheduledPayments[cellInfo.index].scheduledPaymentId,
                  scheduledPayments[cellInfo.index].newChargeDate ?
                    scheduledPayments[cellInfo.index].newChargeDate.valueOf() :
                    scheduledPayments[cellInfo.index].chargeDate.valueOf(),
                  scheduledPayments[cellInfo.index].newAmount ?
                    scheduledPayments[cellInfo.index].newAmount :
                    scheduledPayments[cellInfo.index].amount
                )
                  .then(res => {
                    switch (this.props.membersState.statusCode) {
                      case 200:
                        return this.setState((prevState) => ({
                          scheduledPaymentsForUpdate: [
                            ...prevState.scheduledPaymentsForUpdate.slice(0, cellInfo.index),
                            {
                              ...prevState.scheduledPaymentsForUpdate[cellInfo.index],
                              amount: scheduledPayments[cellInfo.index].newAmount ?
                                scheduledPayments[cellInfo.index].newAmount :
                                scheduledPayments[cellInfo.index].amount,
                              chargeDate: scheduledPayments[cellInfo.index].newChargeDate ?
                                scheduledPayments[cellInfo.index].newChargeDate :
                                scheduledPayments[cellInfo.index].chargeDate,
                              newChargeDate: scheduledPayments[cellInfo.index].newChargeDate ?
                                scheduledPayments[cellInfo.index].newChargeDate :
                                scheduledPayments[cellInfo.index].chargeDate,
                              newAmount: scheduledPayments[cellInfo.index].newAmount ?
                                scheduledPayments[cellInfo.index].newAmount :
                                scheduledPayments[cellInfo.index].amount,
                              editableFieldError: ''
                            },
                            ...prevState.scheduledPaymentsForUpdate.slice(cellInfo.index + 1)
                          ]
                        }));
                      default:
                        return;
                    }
                  });
              } else if (scheduledPayments[cellInfo.index].editableFieldError !== '') {
                return this.setState((prevState) => ({
                  scheduledPaymentsForUpdate: [
                    ...prevState.scheduledPaymentsForUpdate.slice(0, cellInfo.index),
                    {
                      ...prevState.scheduledPaymentsForUpdate[cellInfo.index],
                      amount: prevState.scheduledPaymentsForUpdate[cellInfo.index].amount,
                      chargeDate: scheduledPayments[cellInfo.index].chargeDate,
                      newChargeDate: undefined,
                      newAmount: undefined,
                      editableFieldError: ''
                    },
                    ...prevState.scheduledPaymentsForUpdate.slice(cellInfo.index + 1)
                  ]
                }));
              }
            }
          }}
        />
      );
    } else {
      return null;
    }
  }

  private renderAmountEditable = (cellInfo, scheduledPayments, isNew) => {
    const { selectedPaymentMethod } = this.state;

    return (
      <div>
        <input
          style={{
            backgroundColor: '#fafafa'
          }}
          contentEditable={true}
          suppressContentEditableWarning={true}
          onChange={(e) => this.handleScheduledAmountChange(e, cellInfo, isNew)}
          value={scheduledPayments ?
            isNew ? scheduledPayments[cellInfo.index].amount : scheduledPayments[cellInfo.index].newAmount :
            null
          }
          disabled={
            selectedPaymentMethod && selectedPaymentMethod.paymentMethodType === PaymentMethod.CASH ||
            (!isNew && cannotUpdate(PAYMENT, this.props.authState, this.props.adminState))
          }
        />
        {
          scheduledPayments[cellInfo.index].editableFieldError !== '' ?
            <div className="col-12 red">
              {scheduledPayments[cellInfo.index].editableFieldError}
            </div> :
            null
        }
      </div>
    );
  }

  private handleScheduledAmountChange = (e, cellInfo, isPaymentDetailDisplayMode) => {
    const value = e.target.value;

    if (this.state.isNew) {
      return this.setState((prevState) => ({
        selectedPaymentDetail: {
          ...prevState.selectedPaymentDetail,
          newScheduledPayments: prevState.selectedPaymentDetail &&
            prevState.selectedPaymentDetail.newScheduledPayments ?
            [
              ...prevState.selectedPaymentDetail.newScheduledPayments.slice(0, cellInfo.index),
              {
                ...prevState.selectedPaymentDetail.newScheduledPayments[cellInfo.index],
                amount: value,
                editableFieldError: value !== '' &&
                  validator.isDecimal(value) &&
                  (value.includes('.') ? value.split('.')[1].length <= 2 : true) ?
                  '' :
                  'Please enter valid value.',
                status: CREATED
              },
              ...prevState.selectedPaymentDetail.newScheduledPayments.slice(cellInfo.index + 1)
            ] :
            []
        }
      }));
    } else {
      return this.setState((prevState) => ({
        scheduledPaymentsForUpdate: [
          ...prevState.scheduledPaymentsForUpdate.slice(0, cellInfo.index),
          {
            ...prevState.scheduledPaymentsForUpdate[cellInfo.index],
            newAmount: value,
            editableFieldError: value !== '' &&
              validator.isDecimal(value) &&
              (value.includes('.') ? value.split('.')[1].length <= 2 : true) ?
              '' :
              'Please enter valid value.'
          },
          ...prevState.scheduledPaymentsForUpdate.slice(cellInfo.index + 1)
        ]
      }));
    }
  }

  private updateScheduledPaymentsOnChange = (): void => {
    this.setState((prevState) => ({
      selectedPaymentDetail: {
        ...prevState.selectedPaymentDetail,
        newScheduledPayments: this.createNewScheduledPayments(prevState.selectedPaymentDetail)
      }
    }),
      () => this.setState((prevState) => ({
        selectedPaymentDetail: {
          ...prevState.selectedPaymentDetail,
          totalString: this.calculateTotal(),
          total: parseFloat(this.calculateTotal())
        }
      })));
  }

  private createNewScheduledPayments = (selectedPaymentDetail: MakePaymentRequest) => {
    if (selectedPaymentDetail &&
      selectedPaymentDetail.newPaymentInfo &&
      selectedPaymentDetail.newPaymentInfo.term === MONTHLY
    ) {
      return [...Array(selectedPaymentDetail.newPaymentInfo.numberOfTransactions).keys()]
        .map(i => {
          return {
            chargeDate: moment(new Date(
              selectedPaymentDetail.paymentStartDate.year,
              selectedPaymentDetail.paymentStartDate.month - 1,
              selectedPaymentDetail.paymentStartDate.day
            )).add(i, 'months'),
            amount: selectedPaymentDetail.amountPerTransactionString,
            editableFieldError: ''
          };
        });
    } else if (selectedPaymentDetail && selectedPaymentDetail.newPaymentInfo.term === YEARLY) {
      return [...Array(selectedPaymentDetail.newPaymentInfo.numberOfTransactions).keys()]
        .map(i => {
          return {
            chargeDate: moment(new Date(
              selectedPaymentDetail.paymentStartDate.year,
              selectedPaymentDetail.paymentStartDate.month - 1,
              selectedPaymentDetail.paymentStartDate.day
            )).add(i, 'years'),
            amount: selectedPaymentDetail.amountPerTransactionString,
            editableFieldError: ''
          };
        });
    } else if (selectedPaymentDetail && selectedPaymentDetail.newPaymentInfo.term === WEEKLY) {
      return [...Array(selectedPaymentDetail.newPaymentInfo.numberOfTransactions).keys()]
        .map(i => {
          return {
            chargeDate: moment(new Date(
              selectedPaymentDetail.paymentStartDate.year,
              selectedPaymentDetail.paymentStartDate.month - 1,
              selectedPaymentDetail.paymentStartDate.day
            )).add(i, 'weeks'),
            amount: selectedPaymentDetail.amountPerTransactionString,
            editableFieldError: ''
          };
        });
    } else if (selectedPaymentDetail && selectedPaymentDetail.newPaymentInfo.term === BI_WEEKLY) {
      return [...Array(selectedPaymentDetail.newPaymentInfo.numberOfTransactions).keys()]
        .map(i => {
          return {
            chargeDate: moment(new Date(
              selectedPaymentDetail.paymentStartDate.year,
              selectedPaymentDetail.paymentStartDate.month - 1,
              selectedPaymentDetail.paymentStartDate.day
            )).add(i * 2, 'weeks'),
            amount: selectedPaymentDetail.amountPerTransactionString,
            editableFieldError: ''
          };
        });
    } else {
      return [];
    }
  }

  private onDownPaymentChange = (e: React.FormEvent<{}>, newValue: string) => {
    const formatted = newValue.trim();

    this.setState((prevState) => ({
      selectedPaymentDetail: {
        ...prevState.selectedPaymentDetail,
        downPaymentString: formatted,
        downPayment: validator.isDecimal(formatted) ? parseFloat(formatted) : 0,
        downPaymentError: !(isValidAmount(formatted) &&
          (formatted.includes('.') ? formatted.split('.')[1].length <= 2 : true)) ?
          'Please enter a valid amount' :
          ''
      }
    }),
      () => this.setState((prevState) => ({
        selectedPaymentDetail: {
          ...prevState.selectedPaymentDetail,
          totalString: this.calculateTotal(),
          total: parseFloat(this.calculateTotal())
        }
      })));
  }

  private onTermChange = (e: React.SyntheticEvent<{}>, index: number, menuItemValue: PaymentTermCode) => {
    this.setState((prevState) => ({
      selectedPaymentDetail: {
        ...prevState.selectedPaymentDetail,
        newPaymentInfo: {
          ...(prevState.selectedPaymentDetail && prevState.selectedPaymentDetail.newPaymentInfo),
          term: menuItemValue
        }
      }
    }), this.updateScheduledPaymentsOnChange);
  }

  private resetSelectedPaymentDetail = (props: Props) => {
    return {
      id: DEFAULT_PAYMENT.id,
      newPaymentInfo: DEFAULT_PAYMENT,
      downPayment: DEFAULT_DOWN_PAYMENT,
      total: DEFAULT_TOTAL,
      amountPerTransaction: DEFAULT_AMOUNT_PER_TRANSACTION,
      startDate: new Date().getTime(),
      payerId: DEFAULT_PAYER.id,
      memberId: props.membersState.member && props.membersState.member.id,
      paymentMethodId: defaultPaymentMethodWith(PaymentMethod.VOIDCHEQUE).id,
      continuous: false,
      schedules: [],
      // Only for display
      amountPerTransactionError: '',
      paymentError: {
        numOfTransactionError: ''
      },
      downPaymentError: '',
      newPayer: DEFAULT_PAYER,
      newPayMethod: defaultPaymentMethodWith(PaymentMethod.VOIDCHEQUE),
      paymentStartDate: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1, // Javascript's month starts from 0
        day: PAYMENT_START_DAYS.includes(new Date().getDate()) ?
          new Date().getDate() :
          1
      },
      downPaymentString: DEFAULT_ZERO_AMOUNT_STRING,
      amountPerTransactionString: DEFAULT_ZERO_AMOUNT_STRING,
      totalString: DEFAULT_ZERO_AMOUNT_STRING,
      // Not a clean way. This is used in member create/update request.
      newScheduledPayments: []
    };
  }

  private onContinuousPaymentChange = () => this.setState((prevState) => ({
    selectedPaymentDetail: {
      ...prevState.selectedPaymentDetail,
      continuous: prevState.selectedPaymentDetail ? !prevState.selectedPaymentDetail.continuous : false
    }
  }))

  private onNumberOfTransactionsChange = (e: React.FormEvent<{}>, newValue: string) => {
    const { selectedPaymentMethod } = this.state;

    this.setState((prevState) => ({
      selectedPaymentDetail: {
        ...prevState.selectedPaymentDetail,
        paymentError: {
          numOfTransactionError:
            !validator.isNumeric(newValue) ||
              (selectedPaymentMethod && selectedPaymentMethod.paymentMethodType !== PaymentMethod.CASH &&
                ((newValue.length === 1 && newValue === '0') ||
                  (newValue.length === 2 && newValue === '00') ||
                  newValue === undefined ||
                  newValue === ''
                )
              ) ?
              'Must be bigger than 0' :
              ''
        },
        newPaymentInfo: {
          ...(prevState.selectedPaymentDetail && prevState.selectedPaymentDetail.newPaymentInfo),
          numberOfTransactions: (newValue !== '' && validator.isNumeric(newValue))
            ? Number.parseInt(newValue, 10)
            : 0
        }
      }
    }), this.updateScheduledPaymentsOnChange);
  }

  private onStartDateDayChange = (e: {}, index: number, menuItemValue: number) => {
    this.setState((prevState) => ({
      selectedPaymentDetail: {
        ...prevState.selectedPaymentDetail,
        paymentStartDate: {
          ...(prevState.selectedPaymentDetail && prevState.selectedPaymentDetail.paymentStartDate),
          day: menuItemValue
        }
      }
    }), this.updateScheduledPaymentsOnChange);
  }

  private onStartDateMonthChange = (e: {}, index: number, menuItemValue: number) => {
    this.setState((prevState) => ({
      selectedPaymentDetail: {
        ...prevState.selectedPaymentDetail,
        paymentStartDate: {
          ...(prevState.selectedPaymentDetail && prevState.selectedPaymentDetail.paymentStartDate),
          month: menuItemValue
        }
      }
    }), this.updateScheduledPaymentsOnChange);
  }

  private onStartDateYearChange = (e: {}, index: number, menuItemValue: number) => {
    this.setState((prevState) => ({
      selectedPaymentDetail: {
        ...prevState.selectedPaymentDetail,
        paymentStartDate: {
          ...(prevState.selectedPaymentDetail && prevState.selectedPaymentDetail.paymentStartDate),
          year: menuItemValue
        }
      }
    }), this.updateScheduledPaymentsOnChange);
  }

  private onCurrencyChange = (event: React.TouchEvent<HTMLSelectElement>, index: number, value: Currency) => {
    this.setState((prevState) => ({
      selectedPaymentDetail: {
        ...prevState.selectedPaymentDetail,
        newPaymentInfo: {
          ...prevState.selectedPaymentDetail.newPaymentInfo,
          currency: value
        }
      },
    }));
  }

  private onAmountPerTransactionChange = (e: React.FormEvent<{}>, newValue: string): void => {
    const formatted = newValue.trim();

    return this.setState((prevState) => ({
      selectedPaymentDetail: {
        ...prevState.selectedPaymentDetail,
        amountPerTransactionString: formatted,
        amountPerTransaction: validator.isDecimal(formatted) ? parseFloat(formatted) : 0,
        amountPerTransactionError: formatted !== '' &&
          validator.isDecimal(formatted) &&
          (formatted.includes('.') ? newValue.split('.')[1].length <= 2 : true)
          ? prevState.selectedPaymentMethod.paymentMethodType !== PaymentMethod.CASH &&
            parseFloat(formatted) === 0
            ? 'Please enter amount greater than 0.00'
            : ''
          : 'Please enter a valid amount',
        newScheduledPayments: formatted !== '' &&
          validator.isDecimal(formatted) &&
          (formatted.includes('.') ? formatted.split('.')[1].length <= 2 : true)
          ? [...Array(prevState.selectedPaymentDetail.newPaymentInfo.numberOfTransactions).keys()].map(i => {
            return {
              chargeDate: moment(new Date(
                prevState.selectedPaymentDetail.paymentStartDate.year,
                prevState.selectedPaymentDetail.paymentStartDate.month - 1,
                prevState.selectedPaymentDetail.paymentStartDate.day
              )).add(i, 'months'),
              amount: formatted,
              editableFieldError: ''
            };
          })
          : []
      }
    }), () => this.setState((prevState) => ({
      selectedPaymentDetail: {
        ...prevState.selectedPaymentDetail,
        totalString: this.calculateTotal(),
        total: parseFloat(this.calculateTotal())
      }
    })));
  }

  private calculateTotal = (): string => {
    const { selectedPaymentDetail } = this.state;

    const amount = selectedPaymentDetail && selectedPaymentDetail.newScheduledPayments ?
      selectedPaymentDetail.newScheduledPayments.reduce(
        (acc, s) => acc + (validator.isFloat(s.amount) ? parseFloat(s.amount) : 0),
        0) :
      0;

    const downPayment = parseFloat(selectedPaymentDetail.downPaymentString);

    return (amount + (downPayment ? downPayment : 0)).toFixed(2);
  }

  private onDescriptionChange = (e: React.FormEvent<{}>, newValue: string): void => {
    this.setState((prevState) =>
      ({
        selectedPaymentDetail: {
          ...prevState.selectedPaymentDetail,
          description: newValue,
          descriptionError: newValue.length > MAX_LENGTH ? 'Description is too long' : '',
        }
      })
    );
  }

  private renderPayMethodForm = (): JSX.Element => {
    const {
      isPaymentMethodDisplayMode,
      selectedPaymentMethod,
      payMethodRequest,
      prevSelectedPaymentMethodType
    } = this.state;

    return (
      <div
        className={isPaymentMethodDisplayMode &&
          selectedPaymentMethod &&
          selectedPaymentMethod.paymentMethodType !== PaymentMethod.CASH ?
          'border border-secondary pl-2 pr-2 pt-2 pb-2 mt-2 mb-2' :
          null}
      >
        {!isPaymentMethodDisplayMode && !selectedPaymentMethod ?
          <div className="row">
            <div className="col-12">
              <RadioButtonGroup
                name="paymentMethodRadioGroup"
                valueSelected={payMethodRequest.payMethodType}
                onChange={this.onPayMethodTypeChange}
              >
                {
                  this.availablePaymentMethods().map((method: PaymentMethodType, index: number) => {
                    if (prevSelectedPaymentMethodType === '' ||
                      prevSelectedPaymentMethodType === method) {
                      return (
                        <RadioButton
                          key={index}
                          value={method}
                          label={PaymentMethodLabel[method]}
                          className="float-left ml-2"
                          style={{ width: 'auto', whiteSpace: 'nowrap' }}
                          iconStyle={{ marginRight: '5px' }}
                        />
                      );
                    } else {
                      return (
                        <RadioButton
                          key={index}
                          value={method}
                          label={PaymentMethodLabel[method]}
                          className="float-left ml-2"
                          style={{ width: 'auto', whiteSpace: 'nowrap' }}
                          iconStyle={{ marginRight: '5px' }}
                          disabled={true}
                        />
                      );
                    }
                  })
                }
              </RadioButtonGroup>
            </div>
          </div> :
          null
        }
        {this.renderPayMethodForms()}
      </div>
    );
  }

  private renderPayMethodForms = (): JSX.Element => {
    const {
      isPaymentMethodDisplayMode,
      selectedPaymentMethod,
      payMethodRequest,
    } = this.state;

    if ((
      isPaymentMethodDisplayMode &&
      selectedPaymentMethod &&
      selectedPaymentMethod.paymentMethodType === PaymentMethod.VOIDCHEQUE
    ) || (
        !isPaymentMethodDisplayMode &&
        payMethodRequest &&
        payMethodRequest.payMethodType === PaymentMethod.VOIDCHEQUE
      )) {
      return this.renderVoidChequeForm();
    } else if ((
      isPaymentMethodDisplayMode &&
      selectedPaymentMethod &&
      selectedPaymentMethod.paymentMethodType === PaymentMethod.CREDITCARD
    ) || (
        !isPaymentMethodDisplayMode &&
        payMethodRequest &&
        payMethodRequest.payMethodType === PaymentMethod.CREDITCARD
      )) {
      return this.renderCreditcardForm();
    } else {
      return null;
    }
  }

  private renderCreditcardForm = (): JSX.Element => {
    const {
      isPaymentMethodDisplayMode,
      selectedPaymentMethod,
      payMethodRequest,
      newPayMethodRequestError,
    } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-12">
            <TextField
              className="material-input-required-red"
              fullWidth={true}
              floatingLabelText="Card Holder Name"
              floatingLabelFixed={true}
              errorText={newPayMethodRequestError && newPayMethodRequestError.creditcard ?
                newPayMethodRequestError.creditcard.cardHolderNameError :
                ''
              }
              value={selectedPaymentMethod && selectedPaymentMethod.paymentMethodType === PaymentMethod.CREDITCARD ?
                selectedPaymentMethod.cardHolderName :
                payMethodRequest && payMethodRequest.creditcard ?
                  payMethodRequest.creditcard.cardHolderName :
                  ''
              }
              onChange={this.onCardHolderNameChange}
              disabled={isPaymentMethodDisplayMode}
              style={isPaymentMethodDisplayMode ? fieldStyles.rootStyle : {}}
              inputStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            {!isPaymentMethodDisplayMode &&
              payMethodRequest &&
              payMethodRequest.creditcard &&
              payMethodRequest.creditcard.creditCardType ?
              renderCreditCardIcon(payMethodRequest.creditcard.creditCardType) :
              null
            }
            <TextField
              className="material-input-required-red"
              fullWidth={true}
              floatingLabelText="Card Number"
              floatingLabelFixed={true}
              errorText={newPayMethodRequestError && newPayMethodRequestError.creditcard ?
                newPayMethodRequestError.creditcard.cardNumberError :
                ''
              }
              value={selectedPaymentMethod && selectedPaymentMethod.paymentMethodType === PaymentMethod.CREDITCARD ?
                this.formatCardNumber(selectedPaymentMethod.cardNumber) :
                payMethodRequest && payMethodRequest.creditcard ?
                  this.formatCardNumber(payMethodRequest.creditcard.cardNumber) :
                  ''
              }
              onChange={this.onCardNumberChange}
              disabled={isPaymentMethodDisplayMode}
              style={isPaymentMethodDisplayMode ? fieldStyles.rootStyle : {}}
              inputStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <TextField
              className="material-input-required-red"
              fullWidth={true}
              floatingLabelText="MM (e.g. 01 - 12)"
              floatingLabelFixed={true}
              errorText={newPayMethodRequestError && newPayMethodRequestError.creditcard ?
                newPayMethodRequestError.creditcard.mmyyError :
                ''
              }
              value={selectedPaymentMethod && selectedPaymentMethod.paymentMethodType === PaymentMethod.CREDITCARD ?
                selectedPaymentMethod.expiryMonth :
                payMethodRequest && payMethodRequest.creditcard ?
                  payMethodRequest.creditcard.mm :
                  ''
              }
              onChange={this.onExpiryMonthChange}
              disabled={isPaymentMethodDisplayMode}
              style={isPaymentMethodDisplayMode ? fieldStyles.rootStyle : {}}
              inputStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
            />
          </div>
          <div className="col-6">
            <TextField
              className="material-input-required-red"
              fullWidth={true}
              floatingLabelText="YY"
              floatingLabelFixed={true}
              errorText={newPayMethodRequestError && newPayMethodRequestError.creditcard ?
                newPayMethodRequestError.creditcard.mmyyError :
                ''
              }
              value={selectedPaymentMethod && selectedPaymentMethod.paymentMethodType === PaymentMethod.CREDITCARD ?
                selectedPaymentMethod.expiryYear :
                payMethodRequest && payMethodRequest.creditcard ?
                  payMethodRequest.creditcard.yy :
                  ''
              }
              onChange={this.onExpiryYearChange}
              disabled={isPaymentMethodDisplayMode}
              style={isPaymentMethodDisplayMode ? fieldStyles.rootStyle : {}}
              inputStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
            />
          </div>
        </div>
        {!isPaymentMethodDisplayMode ?
          <div className="row">
            <div className="col-6">
              <TextField
                className="material-input-required-red"
                fullWidth={true}
                floatingLabelText="CVC"
                floatingLabelFixed={true}
                errorText={newPayMethodRequestError && newPayMethodRequestError.creditcard ?
                  newPayMethodRequestError.creditcard.cvcError :
                  ''
                }
                value={payMethodRequest && payMethodRequest.creditcard ?
                  payMethodRequest.creditcard.cvc :
                  ''
                }
                onChange={this.onCvcChange}
              />
            </div>
          </div>
          : null
        }
      </div>
    );
  }

  private onCvcChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState((prevState) => ({
      payMethodRequest: {
        ...prevState.payMethodRequest,
        creditcard: {
          ...(prevState.payMethodRequest && prevState.payMethodRequest.creditcard),
          cvc: newValue
        }
      },
      newPayMethodRequestError: {
        ...prevState.newPayMethodRequestError,
        creditcard: {
          ...(prevState.newPayMethodRequestError && prevState.newPayMethodRequestError.creditcard),
          cvcError: validator.isNumeric(newValue) ? '' : 'Please enter a valid CVC.'
        }
      }
    }))

  private onExpiryMonthChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState((prevState) => ({
      payMethodRequest: {
        ...prevState.payMethodRequest,
        creditcard: {
          ...(prevState.payMethodRequest && prevState.payMethodRequest.creditcard),
          mm: newValue
        }
      },
      newPayMethodRequestError: {
        ...prevState.newPayMethodRequestError,
        creditcard: {
          ...(prevState.newPayMethodRequestError && prevState.newPayMethodRequestError.creditcard),
          mmyyError: this.validateExpiryDate(
            newValue,
            prevState.payMethodRequest &&
              prevState.payMethodRequest.creditcard ?
              prevState.payMethodRequest.creditcard.yy :
              ''
          )
        }
      }
    }))

  private onExpiryYearChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState((prevState) => ({
      payMethodRequest: {
        ...prevState.payMethodRequest,
        creditcard: {
          ...(prevState.payMethodRequest && prevState.payMethodRequest.creditcard),
          yy: newValue
        }
      },
      newPayMethodRequestError: {
        ...prevState.newPayMethodRequestError,
        creditcard: {
          ...(prevState.newPayMethodRequestError && prevState.newPayMethodRequestError.creditcard),
          mmyyError: this.validateExpiryDate(
            prevState.payMethodRequest &&
              prevState.payMethodRequest.creditcard ?
              prevState.payMethodRequest.creditcard.mm :
              '',
            newValue
          )
        }
      }
    }))

  private validateExpiryDate = (month?: string, year?: string): string => {
    let errorMessage = '';

    errorMessage = month &&
      validator.isNumeric(month) &&
      parseInt(month, 10) > 0 &&
      parseInt(month, 10) <= 12 &&
      month.length === 2 ?
      '' :
      'Please enter a valid Expiry Date.';

    errorMessage = year &&
      errorMessage === '' &&
      validator.isNumeric(year) ?
      '' :
      'Please enter a valid Expiry Date.';

    if (errorMessage === '' && month && year) {
      let currentMonth = new Date().getMonth();
      let currentYear = new Date().getFullYear() % 100; // Last two digit
      let selectedMonth = Number.parseInt(month, 10);
      let selectedYear = Number.parseInt(year, 10);

      if (selectedMonth > 12
        || selectedMonth < 1
        || year.length > 2
        || selectedYear < currentYear
        || (selectedYear === currentYear
          && selectedMonth <= currentMonth)
      ) {
        errorMessage = 'Please select a valid expiry date.';
      }
    }

    return errorMessage;
  }

  private onCardNumberChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void => {
    const trimmedValue = newValue.replace(/\s/g, '');

    this.setState((prevState) => ({
      payMethodRequest: {
        ...prevState.payMethodRequest,
        creditcard: {
          ...(prevState.payMethodRequest && prevState.payMethodRequest.creditcard),
          cardNumber: trimmedValue,
          creditCardType: (
            (trimmedValue.length === CREDIT_CARD_LENGTH &&
              trimmedValue.charAt(0) !== '3') ||
            (trimmedValue.length === AMEX_LENGTH &&
              trimmedValue.charAt(0) === '3')) &&
            validateCreditCardNumber(trimmedValue) ?
            parseCreditCardType(trimmedValue) :
            NONE
        }
      },
      newPayMethodRequestError: {
        ...prevState.newPayMethodRequestError,
        creditcard: {
          ...(prevState.newPayMethodRequestError && prevState.newPayMethodRequestError.creditcard),
          cardNumberError: (
            (trimmedValue.length === CREDIT_CARD_LENGTH &&
              trimmedValue.charAt(0) !== '3') ||
            (trimmedValue.length === AMEX_LENGTH &&
              trimmedValue.charAt(0) === '3')) &&
            validateCreditCardNumber(newValue) ?
            '' :
            'Enter valid creditcard number'
        }
      }
    }));
  }

  private formatCardNumber = (cardNumber: string): string => {
    if (cardNumber && validator.isNumeric(cardNumber)) {
      return creditcardutils.formatCardNumber(cardNumber);
    }
    return cardNumber;
  }

  private onCardHolderNameChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState((prevState) => ({
      payMethodRequest: {
        ...prevState.payMethodRequest,
        creditcard: {
          ...(prevState.payMethodRequest && prevState.payMethodRequest.creditcard),
          cardHolderName: newValue
        }
      },
      newPayMethodRequestError: {
        ...prevState.newPayMethodRequestError,
        creditcard: {
          ...(prevState.newPayMethodRequestError && prevState.newPayMethodRequestError.creditcard),
          cardHolderNameError: !isValidName(newValue) ?
            'Please enter a valid name.' :
            newValue.length > MAX_LENGTH ?
              'Name is too long' :
              ''
        }
      }
    }))

  private renderVoidChequeForm = (): JSX.Element => {
    const {
      isPaymentMethodDisplayMode,
      selectedPaymentMethod,
      payMethodRequest,
      newPayMethodRequestError,
    } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-12">
            <div className="input-group mb-2 mr-sm-2 mb-sm-0">
              <TextField
                className="material-input-required-red"
                fullWidth={true}
                floatingLabelText="Account Holder Name"
                floatingLabelFixed={true}
                errorText={newPayMethodRequestError && newPayMethodRequestError.voidCheque ?
                  newPayMethodRequestError.voidCheque.accountHolderNameError :
                  ''
                }
                value={selectedPaymentMethod && selectedPaymentMethod.paymentMethodType === PaymentMethod.VOIDCHEQUE ?
                  selectedPaymentMethod.accountHolderName :
                  payMethodRequest && payMethodRequest.voidCheque ?
                    payMethodRequest.voidCheque.accountHolderName :
                    ''
                }
                onChange={this.onAccountHolderNameChange}
                disabled={isPaymentMethodDisplayMode}
                style={isPaymentMethodDisplayMode ? fieldStyles.rootStyle : {}}
                inputStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
                floatingLabelStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="input-group mb-2 mr-sm-2 mb-sm-0">
              <TextField
                className="material-input-required-red"
                fullWidth={true}
                floatingLabelText="Financial Institution Name"
                floatingLabelFixed={true}
                errorText={newPayMethodRequestError && newPayMethodRequestError.voidCheque ?
                  newPayMethodRequestError.voidCheque.financialInstitutionNameError :
                  ''
                }
                value={selectedPaymentMethod && selectedPaymentMethod.paymentMethodType === PaymentMethod.VOIDCHEQUE ?
                  selectedPaymentMethod.financialInstitutionName :
                  payMethodRequest && payMethodRequest.voidCheque ?
                    payMethodRequest.voidCheque.financialInstitutionName :
                    ''
                }
                onChange={this.onFinancialInstitutionNameChange}
                disabled={isPaymentMethodDisplayMode}
                style={isPaymentMethodDisplayMode ? fieldStyles.rootStyle : {}}
                inputStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
                floatingLabelStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <TextField
              className="material-input-required-red"
              fullWidth={true}
              floatingLabelText="Transit Number"
              floatingLabelFixed={true}
              errorText={newPayMethodRequestError && newPayMethodRequestError.voidCheque ?
                newPayMethodRequestError.voidCheque.transitNumberError :
                ''
              }
              value={selectedPaymentMethod && selectedPaymentMethod.paymentMethodType === PaymentMethod.VOIDCHEQUE ?
                selectedPaymentMethod.maskedTransitNumber :
                payMethodRequest && payMethodRequest.voidCheque ?
                  payMethodRequest.voidCheque.transitNumber :
                  ''
              }
              onChange={this.onTransitNumberChange}
              disabled={isPaymentMethodDisplayMode}
              style={isPaymentMethodDisplayMode ? fieldStyles.rootStyle : {}}
              inputStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
            />
          </div>
          <div className="col-6">
            <TextField
              className="material-input-required-red"
              fullWidth={true}
              floatingLabelText="Financial Institution Number"
              floatingLabelFixed={true}
              errorText={newPayMethodRequestError && newPayMethodRequestError.voidCheque ?
                newPayMethodRequestError.voidCheque.financialInstitutionNumberError :
                ''
              }
              value={selectedPaymentMethod && selectedPaymentMethod.paymentMethodType === PaymentMethod.VOIDCHEQUE ?
                selectedPaymentMethod.financialInstitutionNumber :
                payMethodRequest && payMethodRequest.voidCheque ?
                  payMethodRequest.voidCheque.financialInstitutionNumber :
                  ''
              }
              onChange={this.onFinancialInstitutionNumberChange}
              disabled={isPaymentMethodDisplayMode}
              style={isPaymentMethodDisplayMode ? fieldStyles.rootStyle : {}}
              inputStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <TextField
              className="material-input-required-red"
              fullWidth={true}
              floatingLabelText="Bank Account Number"
              floatingLabelFixed={true}
              errorText={newPayMethodRequestError && newPayMethodRequestError.voidCheque ?
                newPayMethodRequestError.voidCheque.bankAccountNumberError :
                ''
              }
              value={selectedPaymentMethod && selectedPaymentMethod.paymentMethodType === PaymentMethod.VOIDCHEQUE ?
                selectedPaymentMethod.maskedBankAccountNumber :
                payMethodRequest && payMethodRequest.voidCheque ?
                  payMethodRequest.voidCheque.bankAccountNumber :
                  ''
              }
              onChange={this.onBankAccountNumberChange}
              disabled={isPaymentMethodDisplayMode}
              style={isPaymentMethodDisplayMode ? fieldStyles.rootStyle : {}}
              inputStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPaymentMethodDisplayMode ? fieldStyles.textStyle : {}}
            />
          </div>
        </div>
      </div>
    );
  }

  private onBankAccountNumberChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState((prevState) => ({
      payMethodRequest: {
        ...prevState.payMethodRequest,
        voidCheque: {
          ...(prevState.payMethodRequest && prevState.payMethodRequest.voidCheque),
          bankAccountNumber: newValue
        }
      },
      newPayMethodRequestError: {
        ...prevState.newPayMethodRequestError,
        voidCheque: {
          ...(prevState.newPayMethodRequestError && prevState.newPayMethodRequestError.voidCheque),
          bankAccountNumberError: !validator.isNumeric(newValue) ?
            'Please enter numeric value.' :
            newValue.length > CANADA_MAX_ACCOUNT_NUMBER_LENGTH ?
              'Please enter a valid bank account number.' :
              ''
        }
      }
    }))

  private onFinancialInstitutionNumberChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState((prevState) => ({
      payMethodRequest: {
        ...prevState.payMethodRequest,
        voidCheque: {
          ...(prevState.payMethodRequest && prevState.payMethodRequest.voidCheque),
          financialInstitutionNumber: newValue
        }
      },
      newPayMethodRequestError: {
        ...prevState.newPayMethodRequestError,
        voidCheque: {
          ...(prevState.newPayMethodRequestError && prevState.newPayMethodRequestError.voidCheque),
          financialInstitutionNumberError: !validator.isNumeric(newValue) ?
            'Please enter numeric value.' :
            newValue.length !== CANADA_FINANCIAL_INSTITUTION_NUMBER_LENGTH ?
              'Please enter a valid financial institution number.' :
              ''
        }
      }
    }))

  private onTransitNumberChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState((prevState) => ({
      payMethodRequest: {
        ...prevState.payMethodRequest,
        voidCheque: {
          ...(prevState.payMethodRequest && prevState.payMethodRequest.voidCheque),
          transitNumber: newValue
        }
      },
      newPayMethodRequestError: {
        ...prevState.newPayMethodRequestError,
        voidCheque: {
          ...(prevState.newPayMethodRequestError && prevState.newPayMethodRequestError.voidCheque),
          transitNumberError: !validator.isNumeric(newValue) ?
            'Please enter numeric value.' :
            newValue.length !== CANADA_TRANSIT_NUMBER_LENGTH ?
              'Please enter a valid transit number.' :
              ''
        }
      }
    }))

  private onAccountHolderNameChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState((prevState) => ({
      payMethodRequest: {
        ...prevState.payMethodRequest,
        voidCheque: {
          ...(prevState.payMethodRequest && prevState.payMethodRequest.voidCheque),
          accountHolderName: newValue
        }
      },
      newPayMethodRequestError: {
        ...prevState.newPayMethodRequestError,
        voidCheque: {
          ...(prevState.newPayMethodRequestError && prevState.newPayMethodRequestError.voidCheque),
          accountHolderNameError: !isValidName(newValue) ?
            'Please enter a valid name.' :
            newValue.length > MAX_LENGTH ?
              'Name is too long' :
              ''
        }
      }
    }))

  private onFinancialInstitutionNameChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState((prevState) => ({
      payMethodRequest: {
        ...prevState.payMethodRequest,
        voidCheque: {
          ...(prevState.payMethodRequest && prevState.payMethodRequest.voidCheque),
          financialInstitutionName: newValue
        }
      },
      newPayMethodRequestError: {
        ...prevState.newPayMethodRequestError,
        voidCheque: {
          ...(prevState.newPayMethodRequestError && prevState.newPayMethodRequestError.voidCheque),
          financialInstitutionNameError: newValue.length > MAX_LENGTH ?
            'Name is too long' :
            ''
        }
      }
    }))

  private onPayMethodTypeChange = (event: React.TouchEvent<HTMLInputElement>, value: PaymentMethodType): void => {
    this.setState((prevState) => ({
      payMethodRequest: {
        ...prevState.payMethodRequest,
        payMethodType: value
      }
    }));
  }

  private availablePaymentMethods = (): PaymentMethodType[] => {
    const { businessState, authState, adminState } = this.props;
    const paymentMethods: PaymentMethodType[] = [
      PaymentMethod.VOIDCHEQUE, PaymentMethod.CREDITCARD, PaymentMethod.CASH
    ];

    return isAttendancesDisabled(authState, adminState) ?
      paymentMethods.filter((paymentMethod: PaymentMethodType) => paymentMethod !== PaymentMethod.CASH) :
      businessState.business && businessState.business.servicePackage === M3BASIC ?
        paymentMethods.filter((paymentMethod: PaymentMethodType) => paymentMethod === PaymentMethod.CASH) :
        paymentMethods;
  }

  private renderUpdatingPayerForm = (): JSX.Element => {
    return (
      <div className="border border-secondary pl-2 pr-2 pb-2 pt-2 mt-2 mb-2">
        <h4><b>Payer Info</b></h4>
        <div className="row">
          <b className="col-12 text-center">
            UPDATING PAYER INFO
          </b>
          <div className="col-12 text-center">
            {this.renderLoadingCircle()}
          </div>
        </div>
      </div>
    );
  }

  private renderLoadingCircle = (): JSX.Element => {
    return (
      <RefreshIndicator
        size={40}
        left={0}
        top={0}
        status="loading"
        style={{
          display: 'inline-block',
          position: 'relative',
        }}
      />
    );
  }

  private handlePaymentMethodDelete = () => {
    this.setState({ loadingDeletePayMethod: true }, () =>
      this.props.removePayMethod(this.state.selectedPaymentMethod.id)
        .then(res => {
          switch (this.props.payMethodsState.statusCode) {
            case 417:
              this.setState({
                deletingPayMethodError: 'Something went wrong. Please check Credit Card inputs again.',
                loadingDeletePayMethod: false
              });
              break;
            case 406:
              this.setState({
                deletingPayMethodError: 'Something went wrong. Please check Credit Card inputs again.',
                loadingDeletePayMethod: false
              });
              break;
            case 409:
              this.setState({
                deletingPayMethodError: 'The payment method is still being used. Therefore, it can\'t be deleted now.',
                loadingDeletePayMethod: false
              });
              break;
            case 404:
              this.setState({
                loadingDeletePayMethod: false
              });
              break;
            case 200:
              this.setState({
                deletingPayMethodError: '',
                selectedPaymentMethod: undefined,
                loadingDeletePayMethod: false
              });
              break;
            default:
              this.setState({
                loadingDeletePayMethod: false
              });
          }
        })
    );
  }

  private renderPaymentMethodSelect = (): JSX.Element => {
    const { selectedPaymentMethod, selectedPayer, loadingPayMethods,
      prevSelectedPaymentMethodType, isNew } = this.state;
    const { authState, adminState, payMethodsState } = this.props;

    if (loadingPayMethods) {
      return (this.renderLoadingCircle());
    } else {
      return (
        <div>
          <SelectField
            fullWidth={true}
            floatingLabelText="Select Pay Method"
            floatingLabelFixed={true}
            value={selectedPaymentMethod}
            onChange={this.onPayMethodChange}
            disabled={isPaymentDisabled(authState, adminState)}
          >
            {
              selectedPayer && payMethodsState.payMethods.map((p, i) => {
                if (isNew || ((p.paymentMethodType === prevSelectedPaymentMethodType) &&
                  p.payer.id === selectedPayer.id)) {
                  return <MenuItem key={i} value={p} primaryText={this.createPayMethodText(p)} />;
                } else {
                  return null;
                }
              })
            }
          </SelectField>
          <b className="red">{loadingPayMethods}</b>
        </div>
      );
    }
  }

  private onPayMethodChange = (
    event: React.TouchEvent<HTMLSelectElement>,
    index: number,
    value: PayMethodsInfo
  ): void => this.setState({ selectedPaymentMethod: value, prevSelectedPaymentMethodType: value.paymentMethodType })

  private createPayMethodText = (p: PayMethodsInfo): string => {
    if (p && p.paymentMethodType === PaymentMethod.VOIDCHEQUE) {
      return this.getTextValueOfPaymentMethodType(p.paymentMethodType) + ' - ' + p.maskedBankAccountNumber;
    } else if (p && p.paymentMethodType === PaymentMethod.CREDITCARD) {
      return this.getTextValueOfPaymentMethodType(p.paymentMethodType) + ' - ' + p.cardNumber
        + ' , ' + p.expiryMonth + '/' + p.expiryYear;
    } else {
      return p && this.getTextValueOfPaymentMethodType(p.paymentMethodType);
    }
  }

  private loadPayMethodsList = () => {
    const { selectedPayer } = this.state;

    if (selectedPayer) {
      return this.handleGetPayMethods(selectedPayer.id);
    } else {
      return;
    }
  }

  private handleGetPayMethods = (payerId: number) => {
    return this.setState({ loadingPayMethods: true },
      () => this.props.getPayMethods(payerId)
        .then(res => {
          switch (this.props.payMethodsState.statusCode) {
            case 404:
              return this.setState({
                loadingPayMethods: false,
                loadingPayMethodsError: 'Failed to load pay methods'
              });
            case 400:
              return this.setState({
                loadingPayMethods: false,
                loadingPayMethodsError: 'Failed to load pay methods'
              });
            case 403:
              return this.setState({
                loadingPayMethods: false,
                loadingPayMethodsError: 'Failed to load pay methods'
              });
            case 406:
              return this.setState({
                loadingPayMethods: false,
                loadingPayMethodsError: 'Failed to load pay methods'
              });
            case 200:
              return this.setState({
                loadingPayMethods: false,
                loadingPayMethodsError: ''
              });
            default:
              return this.setState({
                loadingPayMethods: false
              });
          }
        }));
  }

  private renderPayingMembers = (): JSX.Element => {
    if (this.state.loadingMembers) {
      return (this.renderLoadingCircle());
    } else {
      const { selectedPayer, isPayerDisplayMode } = this.state;

      return (
        <div className={'border border-secondary pl-2 pr-2 pb-2 pt-2 mt-2 mb-2'}>
          <h4><b>Related Members</b></h4>
          <ReactTable
            data={this.props.membersState.members
              .filter(m => selectedPayer && selectedPayer.payingMembers && selectedPayer.payingMembers.includes(m.id))
              .map(m => {
                return {
                  memberId: m.memberId,
                  memberName: m.firstName + ' ' + m.lastName
                };
              })
            }
            columns={[
              {
                Header: 'ID',
                accessor: 'memberId',
                style: { textAlign: 'center' }
              },
              {
                Header: 'Name',
                accessor: 'memberName',
                style: { textAlign: 'center' }
              }]
            }
            defaultPageSize={5}
            className="-striped -highlight"
          />
          <b className="red">{this.state.loadingMembersError}</b>
        </div>
      );
    }
  }

  private renderSearchForPayerInput = (): JSX.Element => {
    if (this.state.loadingPayers) {
      return (this.renderLoadingCircle());
    } else if (this.state.selectedPayer) {
      return (this.renderSelectedPayer());
    } else {
      return (
        <div>
          <AutoComplete
            hintText="Enter name or phone number here"
            floatingLabelText={isPaymentDisabled(this.props.authState, this.props.adminState) ?
              'Not Enough Permission (Payment)' :
              'Search Payer'}
            searchText={this.state.payerSearchText}
            onUpdateInput={this.handlePayerSearchTextUpdate}
            dataSource={this.state.payerSearchData}
            onNewRequest={this.handleNewPayerSearchRequest}
            filter={AutoComplete.caseInsensitiveFilter}
            maxSearchResults={10}
            fullWidth={true}
            disabled={isPaymentDisabled(this.props.authState, this.props.adminState)}
          />
          <b className="red">{this.state.loadingPayersError}</b>
        </div>
      );
    }
  }

  private renderSearchForMemberInput = (): JSX.Element => {
    if (this.state.loadingMembers) {
      return (this.renderLoadingCircle());
    } else if (this.state.selectedMember) {
      return (this.renderSelectedMember());
    } else {
      const { authState, adminState } = this.props;
      const { isNew, memberSearchData, memberSearchText, loadingMembersError } = this.state;

      return (
        <div>
          <div className="row">
            <div className="col-12">
              <AutoComplete
                hintText="Enter name or phone number here"
                floatingLabelText={isMemberDisabled(authState, adminState) ?
                  'Not Enough Permission (Member)' :
                  'Search Member'
                }
                searchText={memberSearchText}
                onUpdateInput={this.handleMemberSearchTextUpdate}
                dataSource={memberSearchData}
                onNewRequest={this.handleNewMemberSearchRequest}
                filter={AutoComplete.caseInsensitiveFilter}
                maxSearchResults={10}
                fullWidth={true}
                disabled={isMemberDisabled(authState, adminState) || !isNew}
              />
            </div>
          </div>
          <b className="red">{loadingMembersError}</b>
        </div>
      );
    }
  }

  private mapPayerInfoToSearchData = (): string[] => {
    return this.props.payersState.payers.map((p: PayerInfo) => p.firstName + ' ' + p.lastName + DIVIDER + p.mobile1);
  }

  private mapMemberToSearchData = (): string[] => {
    return this.props.membersState.members.map((m: Member) => m.firstName + ' ' + m.lastName + DIVIDER + m.mobile1);
  }

  private handlePayerSearchTextUpdate = (value: string): void => this.setState({ payerSearchText: value });

  private handleMemberSearchTextUpdate = (value: string): void => this.setState({ memberSearchText: value });

  private handleNewPayerSearchRequest = (chosenRequest: string, index: number): void =>
    this.setState({
      selectedPayer: this.findPayerInfoWith(chosenRequest),
      selectedPaymentMethod: undefined,
    }, this.loadPayMethodsList)

  private handleNewMemberSearchRequest = (chosenRequest: string, index: number): void =>
    this.setState({ selectedMember: this.findMemberWith(chosenRequest) })

  private findPayerInfoWith = (value: string): PayerInfo => {
    return this.props.payersState.payers.find((p: PayerInfo) =>
      (p.firstName + ' ' + p.lastName) === value.split(DIVIDER)[0] &&
      p.mobile1 === value.split(DIVIDER)[1]
    );
  }

  private findMemberWith = (value: string): Member => {
    return this.props.membersState.members.find((m: Member) =>
      (m.firstName + ' ' + m.lastName) === value.split(DIVIDER)[0] &&
      m.mobile1 === value.split(DIVIDER)[1]
    );
  }

  private renderSelectedPayer = (): JSX.Element => {
    const { selectedPayer, isNew } = this.state;

    return (
      <div>
        <AutoComplete
          hintText="Enter name or phone number here"
          floatingLabelText={isPaymentDisabled(this.props.authState, this.props.adminState) ?
            'Not Enough Permission (Payment)' :
            'Search Payer'}
          searchText={this.state.payerSearchText}
          onUpdateInput={this.handlePayerSearchTextUpdate}
          dataSource={this.state.payerSearchData}
          onNewRequest={this.handleNewPayerSearchRequest}
          filter={AutoComplete.caseInsensitiveFilter}
          maxSearchResults={10}
          fullWidth={true}
          disabled={isPaymentDisabled(this.props.authState, this.props.adminState)}
        />
        <b className="red">{this.state.loadingPayersError}</b>
        <Chip
          onRequestDelete={isNew ? this.handleRequestSelectedPayerDelete : null}
          labelStyle={{ height: 50, width: '100%', fontSize: 18, marginTop: 10 }}
          style={{ height: 50, width: '100%' }}
          deleteIconStyle={{ marginTop: 10 }}
        >
          {selectedPayer && selectedPayer.firstName + ' ' + selectedPayer.lastName} /
        {selectedPayer && selectedPayer.mobile1}
        </Chip>
      </div>
    );
  }

  private renderSelectedMember = (): JSX.Element => {
    const { selectedMember, isNew } = this.state;

    return (
      <Chip
        onRequestDelete={isNew ? this.handleRequestSelectedMemberDelete : null}
        labelStyle={{ height: 50, width: '100%', fontSize: 18, marginTop: 10 }}
        style={{ height: 50, width: '100%' }}
        deleteIconStyle={{ marginTop: 10 }}
      >
        <Avatar
          src={selectedMember && selectedMember.picUrl}
          style={{ height: 50, width: 50 }}
        />
        {selectedMember && selectedMember.firstName + ' ' + selectedMember.lastName} /
        {selectedMember && selectedMember.mobile1}
      </Chip>
    );
  }

  private handleRequestSelectedPayerDelete = (): void => this.setState({
    selectedPayer: undefined,
    selectedPaymentDetail: this.resetSelectedPaymentDetail(this.props),
    selectedPaymentMethod: undefined,
    prevSelectedPaymentMethodType: '',
    payerSearchText: ''
  })

  private handleRequestSelectedMemberDelete = (): void => this.setState({
    selectedMember: undefined,
    memberSearchText: ''
  })

  private renderNewPayerModal = (): JSX.Element => {
    const { creatingPayerError } = this.state;

    return (
      <Dialog
        title="Create New Payer"
        actions={[
          this.renderNewPayerCloseButton(),
          this.renderNewPayerSubmitButton()
        ]}
        open={this.state.openPayerModal}
        autoScrollBodyContent={true}
      >
        {this.renderPayerForm()}
        {creatingPayerError ?
          <div className="row">
            <b className="col-12 text-center red">
              {creatingPayerError}
            </b>
          </div> :
          null
        }
      </Dialog>
    );
  }

  private renderNewPayMethodModal = (): JSX.Element => {
    const { creatingPayMethodError, openNewPaymentMethodModal } = this.state;

    return (
      <Dialog
        title="Create New Payment Method"
        actions={[
          this.renderNewPayMethodCloseButton(),
          this.renderNewPayMethodSubmitButton()
        ]}
        open={openNewPaymentMethodModal}
        autoScrollBodyContent={true}
      >
        {this.renderPayMethodForm()}
        {creatingPayMethodError ?
          <div className="row">
            <b className="col-12 text-center red">
              {creatingPayMethodError}
            </b>
          </div> :
          null
        }
      </Dialog>
    );
  }

  private renderNewPayMethodCloseButton = (): JSX.Element => {
    return (
      <RaisedButton
        label="Close"
        secondary={true}
        keyboardFocused={true}
        className="mr-2"
        onClick={() => this.setState({
          openNewPaymentMethodModal: false,
          isPaymentMethodDisplayMode: true,
          payMethodRequest: {
            payMethodType: PaymentMethod.VOIDCHEQUE
          },
          newPayMethodRequestError: undefined,
          creatingPayMethodError: ''
        })}
      />
    );
  }

  private renderNewPayMethodSubmitButton = (): JSX.Element => {
    if (this.state.loadingCreatePayMethod) {
      return (this.renderLoadingCircle());
    } else {
      return (
        <RaisedButton
          label="Submit"
          primary={true}
          disabled={this.doesErrorExistInPayMethodReq() || this.isPayMethodReqComplete()}
          onClick={() => this.handlePayMethodCreation()}
        />
      );
    }
  }

  private handlePayMethodCreation = () => {
    const { payMethodRequest, selectedPayer } = this.state;
    const { createPayMethod } = this.props;

    if (payMethodRequest &&
      payMethodRequest.voidCheque &&
      payMethodRequest.payMethodType === PaymentMethod.VOIDCHEQUE &&
      selectedPayer
    ) {
      return this.setState({ loadingCreatePayMethod: true }, () =>
        createPayMethod(
          selectedPayer.id,
          payMethodRequest.payMethodType,
          payMethodRequest.voidCheque.accountHolderName,
          payMethodRequest.voidCheque.financialInstitutionName,
          payMethodRequest.voidCheque.transitNumber,
          payMethodRequest.voidCheque.financialInstitutionNumber,
          payMethodRequest.voidCheque.bankAccountNumber,
          null,
          null,
          null,
          null,
          null
        ).then(res => this.handleCreatePayMethodCallBack())
      );
    } else if (payMethodRequest &&
      payMethodRequest.creditcard &&
      payMethodRequest.payMethodType === PaymentMethod.CREDITCARD &&
      selectedPayer
    ) {
      return this.setState({ loadingCreatePayMethod: true }, () =>
        createPayMethod(
          selectedPayer.id,
          payMethodRequest.payMethodType,
          null,
          null,
          null,
          null,
          null,
          payMethodRequest.creditcard.cardHolderName,
          payMethodRequest.creditcard.cardNumber,
          payMethodRequest.creditcard.mm,
          payMethodRequest.creditcard.yy,
          payMethodRequest.creditcard.cvc
        ).then(res => this.handleCreatePayMethodCallBack())
      );
    } else if (payMethodRequest && payMethodRequest.payMethodType === PaymentMethod.CASH && selectedPayer) {
      return this.setState({ loadingCreatePayMethod: true }, () =>
        createPayMethod(
          selectedPayer.id,
          payMethodRequest.payMethodType,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null
        ).then(res => this.handleCreatePayMethodCallBack())
      );
    }
  }

  private handleCreatePayMethodCallBack = (): void => {
    switch (this.props.payMethodsState.statusCode) {
      case 200:
        return this.setState({
          loadingCreatePayMethod: false,
          openNewPaymentMethodModal: false,
          creatingPayMethodError: '',
          selectedPaymentMethod: this.props.payMethodsState.newPayMethod,
          prevSelectedPaymentMethodType: this.props.payMethodsState.newPayMethod.paymentMethodType,
          isPaymentMethodDisplayMode: true
        });
      case 400:
        return this.setState({
          loadingCreatePayMethod: false,
          creatingPayMethodError: 'Failed to create a new payment method.'
        });
      case 404:
        return this.setState({
          loadingCreatePayMethod: false,
          creatingPayMethodError: 'Failed to create a new payment method.'
        });
      case 406:
        return this.setState({
          loadingCreatePayMethod: false,
          creatingPayMethodError: 'Failed to create a new payment method.'
        });
      case 417:
        return this.setState({
          loadingCreatePayMethod: false,
          creatingPayMethodError: 'Failed to create a new payment method.'
        });
      default:
        return this.setState({
          loadingCreatePayMethod: false
        });
    }
  }

  private doesErrorExistInPayMethodReq = (): boolean => {
    const { newPayMethodRequestError } = this.state;

    if (newPayMethodRequestError && newPayMethodRequestError.voidCheque) {
      return newPayMethodRequestError.voidCheque.accountHolderNameError !== '' ||
        newPayMethodRequestError.voidCheque.bankAccountNumberError !== '' ||
        newPayMethodRequestError.voidCheque.financialInstitutionNameError !== '' ||
        newPayMethodRequestError.voidCheque.financialInstitutionNumberError !== '' ||
        newPayMethodRequestError.voidCheque.transitNumberError !== '';
    } else if (newPayMethodRequestError && newPayMethodRequestError.creditcard) {
      return newPayMethodRequestError.creditcard.cardHolderNameError !== '' ||
        newPayMethodRequestError.creditcard.cardNumberError !== '' ||
        newPayMethodRequestError.creditcard.cvcError !== '' ||
        newPayMethodRequestError.creditcard.mmyyError !== '';
    } else {
      return false;
    }
  }

  private isPayMethodReqComplete = (): boolean => {
    const { payMethodRequest } = this.state;

    if (payMethodRequest && payMethodRequest.voidCheque) {
      return payMethodRequest.voidCheque.accountHolderName === '' ||
        payMethodRequest.voidCheque.bankAccountNumber === '' ||
        payMethodRequest.voidCheque.financialInstitutionName === '' ||
        payMethodRequest.voidCheque.financialInstitutionNumber === '' ||
        payMethodRequest.voidCheque.transitNumber === '';
    } else if (payMethodRequest && payMethodRequest.creditcard) {
      return payMethodRequest.creditcard.cardHolderName === '' ||
        payMethodRequest.creditcard.cardNumber === '' ||
        payMethodRequest.creditcard.cvc === '' ||
        payMethodRequest.creditcard.mm === '' ||
        payMethodRequest.creditcard.yy === '';
    } else {
      return false;
    }
  }

  private renderPayerForm = (): JSX.Element => {
    const {
      payerRequest,
      newPayerRequestError,
      isPayerDisplayMode,
      selectedPayer,
      selectedMember,
      checkedSameAsMember,
      isNew
    } = this.state;
    const { authState, adminState } = this.props;

    return (
      <div className={isPayerDisplayMode ? 'border border-secondary pl-2 pr-2 pt-2 pb-2 mt-2 mb-2' : null}>
        <div className="row no-gutters">
          <div className="col-auto pt-2">
            {isPayerDisplayMode ? <h4><b>Payer Info</b></h4> : null}
          </div>
          <div className="col-auto">
            {selectedPayer && isPayerDisplayMode ?
              <FlatButton
                icon={<Edit />}
                onClick={() => this.setState((prevState) => ({
                  openPayerModal: true,
                  isPayerDisplayMode: false,
                  isPayerEditMode: true,
                  payerRequest: prevState.selectedPayer
                }))}
                disabled={cannotUpdate(PAYMENT, authState, adminState)}
              /> :
              null
            }
          </div>
        </div>
        {isPayerDisplayMode ?
          null :
          <div className="row no-gutters">
            <div className="col-1 align-self-start">
              <Checkbox
                checked={checkedSameAsMember}
                onCheck={this.onSameAsMemberChange}
                disabled={
                  cannotWrite(PAYMENT, authState, adminState) || !isNew || !selectedMember
                }
                labelPosition={'left'}
              />
            </div>
            <b className="col-auto align-self-start">
              {selectedMember ? 'Same As Selected Member' : 'Same As Selected Member (Select a Member First)'}
            </b>
          </div>
        }
        <div className="row">
          <div className="col-4">
            <TextField
              className="material-input-required-red"
              fullWidth={true}
              floatingLabelText="First Name"
              floatingLabelFixed={true}
              value={!isPayerDisplayMode ?
                payerRequest ? payerRequest.firstName : '' :
                selectedPayer ? selectedPayer.firstName : ''
              }
              errorText={newPayerRequestError ? newPayerRequestError.firstNameError : ''}
              onChange={this.onFirstNameChange}
              disabled={isPayerDisplayMode}
              style={isPayerDisplayMode ? fieldStyles.rootStyle : {}}
              inputStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
            />
          </div>
          <div className="col-4">
            <TextField
              className="material-input-required-red"
              fullWidth={true}
              floatingLabelText="Last Name"
              floatingLabelFixed={true}
              value={!isPayerDisplayMode ?
                payerRequest ? payerRequest.lastName : '' :
                selectedPayer ? selectedPayer.lastName : ''
              }
              errorText={newPayerRequestError ? newPayerRequestError.lastNameError : ''}
              onChange={this.onLastNameChange}
              disabled={isPayerDisplayMode}
              style={isPayerDisplayMode ? fieldStyles.rootStyle : {}}
              inputStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
            />
          </div>
          <div className="col-4">
            <TextField
              fullWidth={true}
              floatingLabelText="Initial"
              floatingLabelFixed={true}
              value={!isPayerDisplayMode ?
                payerRequest ? payerRequest.initial : '' :
                selectedPayer ? selectedPayer.initial : ''
              }
              errorText={newPayerRequestError ? newPayerRequestError.initialError : ''}
              onChange={this.onInitialChange}
              disabled={isPayerDisplayMode}
              style={isPayerDisplayMode ? fieldStyles.rootStyle : {}}
              inputStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <TextField
              fullWidth={true}
              floatingLabelText="Address"
              floatingLabelFixed={true}
              value={!isPayerDisplayMode ?
                payerRequest ? payerRequest.address : '' :
                selectedPayer ? selectedPayer.address : ''
              }
              errorText={newPayerRequestError ? newPayerRequestError.addressError : ''}
              onChange={this.onAddressChange}
              disabled={isPayerDisplayMode}
              style={isPayerDisplayMode ? fieldStyles.rootStyle : {}}
              inputStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <TextField
              fullWidth={true}
              floatingLabelText="City"
              floatingLabelFixed={true}
              value={!isPayerDisplayMode ?
                payerRequest ? payerRequest.city : '' :
                selectedPayer ? selectedPayer.city : ''
              }
              errorText={newPayerRequestError ? newPayerRequestError.cityError : ''}
              onChange={this.onCityChange}
              disabled={isPayerDisplayMode}
              style={isPayerDisplayMode ? fieldStyles.rootStyle : {}}
              inputStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
            />
          </div>
          <div className="col-4">
            <SelectField
              fullWidth={true}
              floatingLabelText={DEFAULT_COUNTRY_SELECTION}
              floatingLabelFixed={true}
              value={!isPayerDisplayMode ?
                payerRequest ? payerRequest.country : '' :
                selectedPayer ? selectedPayer.country : ''
              }
              onChange={this.onCountryChange}
              disabled={isPayerDisplayMode}
              style={isPayerDisplayMode ? fieldStyles.rootStyle : {}}
              labelStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
            >
              {
                countries.map((country, index) => {
                  return <MenuItem key={index} value={country.code} primaryText={country.name} />;
                })
              }
            </SelectField>
          </div>
          <div className="col-4">
            <SelectField
              fullWidth={true}
              floatingLabelText={DEFAULT_PROVINCE_SELECTION}
              floatingLabelFixed={true}
              value={!isPayerDisplayMode ?
                payerRequest && payerRequest.province ? payerRequest.province : '' :
                selectedPayer && selectedPayer.province ? selectedPayer.province : ''
              }
              onChange={this.onProvinceChange}
              disabled={isPayerDisplayMode}
              style={isPayerDisplayMode ? fieldStyles.rootStyle : {}}
              labelStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
            >
              {
                (payerRequest && payerRequest.country ? getProvinces(payerRequest.country) :
                  selectedPayer && selectedPayer.country ? getProvinces(selectedPayer.country) :
                    []
                )
                  .map((province, index) => {
                    return <MenuItem key={index} value={province.code} primaryText={province.name} />;
                  })
              }
            </SelectField>
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <TextField
              fullWidth={true}
              floatingLabelText="Postal / Zip Code"
              floatingLabelFixed={true}
              errorText={newPayerRequestError ? newPayerRequestError.postalCodeError : ''}
              value={!isPayerDisplayMode ?
                payerRequest && payerRequest.postalCode ? formatPostalCode(payerRequest.postalCode) : '' :
                selectedPayer && selectedPayer.postalCode ?
                  formatPostalCode(selectedPayer.postalCode) :
                  ''
              }
              onChange={this.onPostalCodeChange}
              disabled={isPayerDisplayMode}
              style={isPayerDisplayMode ? fieldStyles.rootStyle : {}}
              inputStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
            />
          </div>
          <div className="col-4">
            <TextField
              className="material-input-required-red"
              fullWidth={true}
              floatingLabelText={'Mobile1'}
              floatingLabelFixed={true}
              errorText={newPayerRequestError ? newPayerRequestError.mobile1Error : ''}
              disabled={isPayerDisplayMode}
              style={isPayerDisplayMode ? fieldStyles.rootStyle : {}}
              inputStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
            >
              <Phone
                countries={['CA']}
                value={!isPayerDisplayMode ?
                  payerRequest ? payerRequest.mobile1 : '' :
                  selectedPayer ? selectedPayer.mobile1 : ''
                }
                onChange={this.onMobile1Change}
                convertToNational={true}
                inputStyle={{ backgroundColor: '#fff', borderBottom: '0px' }}
              />
            </TextField>
          </div>
          <div className="col-4">
            <TextField
              fullWidth={true}
              floatingLabelText={'Mobile2'}
              floatingLabelFixed={true}
              errorText={newPayerRequestError ? newPayerRequestError.mobile2Error : ''}
              disabled={isPayerDisplayMode}
              style={isPayerDisplayMode ? fieldStyles.rootStyle : {}}
              inputStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
            >
              <Phone
                countries={['CA']}
                value={!isPayerDisplayMode ?
                  payerRequest ? payerRequest.mobile2 : '' :
                  selectedPayer ? selectedPayer.mobile2 : ''
                }
                onChange={this.onMobile2Change}
                convertToNational={true}
                inputStyle={{ backgroundColor: '#fff', borderBottom: '0px' }}
              />
            </TextField>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <TextField
              className="material-input-required-red"
              fullWidth={true}
              floatingLabelText="Email"
              floatingLabelFixed={true}
              value={!isPayerDisplayMode ?
                payerRequest ? payerRequest.email : '' :
                selectedPayer ? selectedPayer.email : ''
              }
              errorText={newPayerRequestError ? newPayerRequestError.emailError : ''}
              onChange={this.onEmailChange}
              disabled={isPayerDisplayMode}
              style={isPayerDisplayMode ? fieldStyles.rootStyle : {}}
              inputStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
              floatingLabelStyle={isPayerDisplayMode ? fieldStyles.textStyle : {}}
            />
          </div>
        </div>
      </div>
    );
  }

  private onSameAsMemberChange = () => {
    const { selectedMember } = this.state;

    if (selectedMember) {
      return this.setState((prevState) => ({
        checkedSameAsMember: !prevState.checkedSameAsMember,
        payerRequest: {
          ...prevState.payerRequest,
          email: selectedMember.email,
          mobile2: selectedMember.mobile2,
          mobile1: selectedMember.mobile1,
          postalCode: formatPostalCode(selectedMember.postalCode),
          province: selectedMember.province,
          country: selectedMember.country,
          city: selectedMember.city,
          address: selectedMember.address,
          initial: selectedMember.initial,
          lastName: selectedMember.lastName,
          firstName: selectedMember.firstName
        }
      }));
    }
  }

  private onEmailChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState((prevState) => ({
      payerRequest: {
        ...prevState.payerRequest,
        email: newValue
      },
      newPayerRequestError: {
        ...prevState.newPayerRequestError,
        emailError: isValidEmail(newValue, 'Please enter a valid email')
      }
    }))

  private onMobile1Change = (newPhone: string): void =>
    this.setState((prevState) => ({
      payerRequest: {
        ...prevState.payerRequest,
        mobile1: newPhone
      },
      newPayerRequestError: {
        ...prevState.newPayerRequestError,
        mobile1Error: isValidPhone(newPhone, 'Please enter a valid mobile1 number')
      }
    }))

  private onMobile2Change = (newPhone: string): void =>
    this.setState((prevState) => ({
      payerRequest: {
        ...prevState.payerRequest,
        mobile2: newPhone
      },
      newPayerRequestError: {
        ...prevState.newPayerRequestError,
        mobile2Error: isValidPhone(newPhone, 'Please enter a valid mobile2 number')
      }
    }))

  private onPostalCodeChange = (event: React.FormEvent<HTMLInputElement>, newValue: string) =>
    this.setState((prevState) => ({
      payerRequest: {
        ...prevState.payerRequest,
        postalCode: formatPostalCode(newValue)
      },
      newPayerRequestError: {
        ...prevState.newPayerRequestError,
        postalCodeError: prevState.payerRequest && prevState.payerRequest.country ?
          isValidPostalCode(
            formatPostalCode(newValue), prevState.payerRequest.country, 'Please enter a valid postal / zip code'
          ) :
          'Please select country & province and re-enter postal code'
      }
    }))

  private onCountryChange = (event: React.TouchEvent<HTMLSelectElement>, index: number, value: CountryCode): void =>
    this.setState((prevState) => ({
      payerRequest: {
        ...prevState.payerRequest,
        country: value
      }
    }))

  private onProvinceChange = (event: React.TouchEvent<HTMLSelectElement>, index: number, value: ProvinceCode): void =>
    this.setState((prevState) => ({
      payerRequest: {
        ...prevState.payerRequest,
        province: value
      }
    }))

  private onCityChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState((prevState) => ({
      payerRequest: {
        ...prevState.payerRequest,
        city: newValue
      },
      newPayerRequestError: {
        ...prevState.newPayerRequestError,
        cityError: newValue.length > MAX_LENGTH ?
          'City name is too long' :
          ''
      }
    }))

  private onFirstNameChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState((prevState) => ({
      payerRequest: {
        ...prevState.payerRequest,
        firstName: newValue
      },
      newPayerRequestError: {
        ...prevState.newPayerRequestError,
        firstNameError: !isValidName(newValue) ?
          'Please enter a valid first name.' :
          newValue.length > MAX_LENGTH_FOR_DB ?
            'Name is too long' :
            ''
      }
    }))

  private onAddressChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState((prevState) => ({
      payerRequest: {
        ...prevState.payerRequest,
        address: newValue
      },
      newPayerRequestError: {
        ...prevState.newPayerRequestError,
        addressError: newValue.length > MAX_LENGTH ?
          'Address is too long' :
          ''
      }
    }))

  private onLastNameChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState((prevState) => ({
      payerRequest: {
        ...prevState.payerRequest,
        lastName: newValue
      },
      newPayerRequestError: {
        ...prevState.newPayerRequestError,
        lastNameError: !isValidName(newValue) ?
          'Please enter a valid last name.' :
          newValue.length > MAX_LENGTH_FOR_DB ?
            'Name is too long' :
            ''
      }
    }))

  private onInitialChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState((prevState) => ({
      payerRequest: {
        ...prevState.payerRequest,
        initial: newValue
      },
      newPayerRequestError: {
        ...prevState.newPayerRequestError,
        initialError: !isValidName(newValue) ?
          'Please enter a valid initial.' :
          newValue.length > MAX_LENGTH_FOR_DB ?
            'Initial is too long' :
            ''
      }
    }))

  private renderNewPayerCloseButton = (): JSX.Element => {
    return (
      <RaisedButton
        label="Close"
        secondary={true}
        keyboardFocused={true}
        className="mr-2"
        onClick={() => this.setState({
          openPayerModal: false,
          isPayerDisplayMode: true,
          payerRequest: undefined,
          newPayerRequestError: undefined,
          checkedSameAsMember: false
        })}
      />
    );
  }

  private renderNewPayerSubmitButton = (): JSX.Element => {
    if (this.state.loadingCreatePayer || this.state.loadingUpdatePayer) {
      return (this.renderLoadingCircle());
    } else if (this.state.isPayerEditMode) {
      return (
        <RaisedButton
          label="Update"
          primary={true}
          disabled={this.doesErrorExistInPayerReq()}
          onClick={() => this.handlePayerUpdate()}
        />
      );
    } else {
      return (
        <RaisedButton
          label="Submit"
          primary={true}
          disabled={this.doesErrorExistInPayerReq() || this.isPayerReqIncomplete()}
          onClick={() => this.handlePayerCreation()}
        />
      );
    }
  }

  private handlePayerUpdate = (): void => {
    const { businessState } = this.props;
    const { payerRequest } = this.state;

    this.setState({ loadingUpdatePayer: true }, () => {
      this.props.updatePayer(
        businessState.business ? businessState.business.id : 0,
        payerRequest.id,
        payerRequest.firstName,
        payerRequest.lastName,
        payerRequest.initial,
        payerRequest.address,
        payerRequest.city,
        payerRequest.country,
        payerRequest.province,
        payerRequest.postalCode,
        payerRequest.mobile1,
        payerRequest.mobile2,
        payerRequest.email,
      )
        .then(res => {
          switch (this.props.payersState.statusCode) {
            case 200:
              return this.setState({
                openPayerModal: false,
                isPayerDisplayMode: true,
                payerRequest: undefined,
                newPayerRequestError: undefined,
                selectedPayer: this.props.payersState.updatedPayer,
                loadingUpdatePayer: false,
                updatingPayerError: '',
                payerSearchData: this.mapPayerInfoToSearchData()
              }, this.loadPayMethodsList);
            case 400:
              return this.setState({
                loadingUpdatePayer: false,
                updatingPayerError: 'Failed to create a payer. Please check inputs.'
              });
            case 403:
              return this.setState({
                loadingUpdatePayer: false,
                updatingPayerError: 'Failed to create a payer. Please check inputs.'
              });
            case 406:
              return this.setState({
                loadingUpdatePayer: false,
                updatingPayerError: 'Failed to create a payer. Please check inputs.'
              });
            default:
              return this.setState({
                loadingUpdatePayer: false
              });
          }
        });
    });
  }

  private handlePayerCreation = (): void => {
    const { businessState } = this.props;
    const { payerRequest, checkedSameAsMember, selectedMember } = this.state;

    this.setState({ loadingCreatePayer: true }, () => {
      this.props.createPayer(
        businessState.business ? businessState.business.id : 0,
        payerRequest.firstName,
        payerRequest.lastName,
        payerRequest.initial,
        payerRequest.address,
        payerRequest.city,
        payerRequest.country,
        payerRequest.province,
        payerRequest.postalCode,
        payerRequest.mobile1,
        payerRequest.mobile2,
        payerRequest.email,
      )
        .then(res => {
          switch (this.props.payersState.statusCode) {
            case 200:
              return this.setState({
                openPayerModal: false,
                checkedSameAsMember: false,
                isPayerDisplayMode: true,
                payerRequest: undefined,
                newPayerRequestError: undefined,
                selectedPayer: this.props.payersState.newPayer,
                loadingCreatePayer: false,
                creatingPayerError: '',
                payerSearchData: this.mapPayerInfoToSearchData()
              }, this.loadPayMethodsList);
            case 400:
              return this.setState({
                loadingCreatePayer: false,
                creatingPayerError: 'Failed to create a payer. Please check inputs.'
              });
            case 403:
              return this.setState({
                loadingCreatePayer: false,
                creatingPayerError: 'Failed to create a payer. Please check inputs.'
              });
            case 406:
              return this.setState({
                loadingCreatePayer: false,
                creatingPayerError: 'Failed to create a payer. Please check inputs.'
              });
            default:
              return this.setState({
                loadingCreatePayer: false
              });
          }
        });
    });
  }

  private doesErrorExistInPayerReq = (): boolean => {
    const { newPayerRequestError } = this.state;

    return newPayerRequestError && (
      (newPayerRequestError.addressError && newPayerRequestError.addressError !== '') ||
      (newPayerRequestError.cityError && newPayerRequestError.cityError !== '') ||
      (newPayerRequestError.emailError && newPayerRequestError.emailError !== '') ||
      (newPayerRequestError.firstNameError && newPayerRequestError.firstNameError !== '') ||
      (newPayerRequestError.lastNameError && newPayerRequestError.lastNameError !== '') ||
      (newPayerRequestError.initialError && newPayerRequestError.initialError !== '') ||
      (newPayerRequestError.mobile1Error && newPayerRequestError.mobile1Error !== '') ||
      (newPayerRequestError.mobile2Error && newPayerRequestError.mobile2Error !== '') ||
      (newPayerRequestError.postalCodeError && newPayerRequestError.postalCodeError !== '')
    );
  }

  private isPayerReqIncomplete = (): boolean => {
    const { payerRequest, checkedSameAsMember, selectedMember } = this.state;

    return !checkedSameAsMember && !selectedMember && (
      payerRequest === undefined ||
      (payerRequest.address === undefined || payerRequest.address === '') ||
      (payerRequest.city === undefined || payerRequest.city === '') ||
      (payerRequest.country === undefined || payerRequest.country === '') ||
      (payerRequest.email === undefined || payerRequest.email === '') ||
      (payerRequest.firstName === undefined || payerRequest.firstName === '') ||
      (payerRequest.lastName === undefined || payerRequest.lastName === '') ||
      (payerRequest.mobile1 === undefined || payerRequest.mobile1 === '') ||
      (payerRequest.province === undefined || payerRequest.province === '') ||
      (payerRequest.postalCode === undefined || payerRequest.postalCode === '')
    );
  }

  private getTextValueOfPaymentMethodType = (paymentMethodType: string): string => {
    if (paymentMethodType === 'CASH') {
      return 'Cash';
    } else if (paymentMethodType === 'VOIDCHEQUE') {
      return 'E.F.T.';
    } else {
      return 'Credit Card';
    }
  }

  private getTextValueOfPaymentStatus = (paymentStatus: string): string => {
    if (paymentStatus === 'SCHEDULED') {
      return 'Scheduled';
    } else if (paymentStatus === 'SUBMITTED') {
      return 'Submitted';
    } else if (paymentStatus === 'SUCCEEDED') {
      return 'Succeeded';
    } else if (paymentStatus === 'FAILED') {
      return 'Failed';
    } else {
      return 'Deposited';
    }
  }

  private isSelected = (key) => {
    /*
      Instead of passing our external selection state we provide an 'isSelected'
      callback and detect the selection state ourselves. This allows any implementation
      for selection (either an array, object keys, or even a Javascript Set object).
    */
    return this.state.selection.includes(key);
  }

  private toggleSelection = (key, shift, row) => {
    /*
      Implementation of how to manage the selection state is up to the developer.
      This implementation uses an array stored in the component state.
      Other implementations could use object keys, a Javascript Set, or Redux... etc.
    */
    // start off with the existing state
    let selection = [
      ...this.state.selection
    ];
    const keyIndex = selection.indexOf(key);
    // check to see if the key exists
    if (keyIndex >= 0) {
      // it does exist so we will remove it using destructing
      selection = [
        ...selection.slice(0, keyIndex),
        ...selection.slice(keyIndex + 1)
      ];
    } else {
      // it does not exist so add it
      selection.push(key);
    }
    // update the state
    this.setState({ selection });
  }

  private toggleAll = () => {
    /*
      'toggleAll' is a tricky concept with any filterable table
      do you just select ALL the records that are in your data?
      OR
      do you only select ALL the records that are in the current filtered data?
      
      The latter makes more sense because 'selection' is a visual thing for the user.
      This is especially true if you are going to implement a set of external functions
      that act on the selected information (you would not want to DELETE the wrong thing!).
      
      So, to that end, access to the internals of ReactTable are required to get what is
      currently visible in the table (either on the current page or any other page).
      
      The HOC provides a method call 'getWrappedInstance' to get a ref to the wrapped
      ReactTable and then get the internal state and the 'sortedData'. 
      That can then be iterrated to get all the currently visible records and set
      the selection state.
    */
    const selectAll = !this.state.selectAll;
    const selection = [];
    if (selectAll) {
      // we need to get at the internals of ReactTable
      const wrappedInstance = this.checkboxTable.getWrappedInstance();
      // the 'sortedData' property contains the currently accessible records based on the filter and sort
      const currentRecords = wrappedInstance.getResolvedState().sortedData;
      // we just push all the IDs onto the selection array
      currentRecords.forEach((item) => {
        selection.push(item._original.id);
      });
    }
    this.setState({ selectAll, selection });
  }

}

export default PaymentListComponent;


// WEBPACK FOOTER //
// ./src/payments/PaymentListComponent.tsx